export const villageGraph = [
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '芳苑村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-001',
      VILLAGE_ID: '001',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.322171991, 23.935014100999958],
          [120.32366372700001, 23.93277724499999],
          [120.324820509, 23.931020959999987],
          [120.325850066000044, 23.929632116999958],
          [120.326419768000051, 23.928991234],
          [120.326648431000066, 23.928585392999977],
          [120.327376164000029, 23.927254504999986],
          [120.328209974000046, 23.925917823],
          [120.328738357, 23.925295675000019],
          [120.325787429, 23.924823528999958],
          [120.322695648000021, 23.924371559999976],
          [120.321264272999983, 23.924119410999971],
          [120.320635819000017, 23.923815295999969],
          [120.32040854300007, 23.924027714000015],
          [120.319111936000013, 23.92485633699998],
          [120.318239574, 23.925276452999956],
          [120.317956430000109, 23.925412810999973],
          [120.317853336000113, 23.925451733999957],
          [120.317801991999971, 23.925699752],
          [120.31763048600007, 23.925965614999988],
          [120.317149536000088, 23.926139900999981],
          [120.317256257000039, 23.926375324999963],
          [120.317350684000061, 23.926597203000028],
          [120.317352372000073, 23.926639400999978],
          [120.317345621000072, 23.926674847999987],
          [120.317289919000018, 23.92674236499999],
          [120.317161636000037, 23.926809881999986],
          [120.316813923000026, 23.926917908999972],
          [120.316471274000037, 23.927002306],
          [120.316277162, 23.927037751999972],
          [120.315818045000015, 23.927164347000019],
          [120.31556713800002, 23.92728733400002],
          [120.315698176000069, 23.92766640799999],
          [120.315393981000057, 23.927736606999968],
          [120.31555777800007, 23.928663232999984],
          [120.315200263000065, 23.929199297],
          [120.314946053000085, 23.929272073999964],
          [120.280592033000033, 23.939227877],
          [120.281615968000111, 23.943450528],
          [120.281290422000069, 23.944772094000022],
          [120.280990054000085, 23.945220114999973],
          [120.280564514000034, 23.946012851000017],
          [120.280439109000099, 23.947173639],
          [120.28032620700003, 23.948403379],
          [120.280463693000016, 23.94892073599997],
          [120.280463828000023, 23.94892109399999],
          [120.280464052000056, 23.948921015999961],
          [120.31867181699999, 23.935631832],
          [120.32069625500003, 23.93545563199999],
          [120.321423179, 23.935344453],
          [120.321745235000094, 23.93526961000001],
          [120.322171991, 23.935014100999958],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '芳中村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-002',
      VILLAGE_ID: '002',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.318239574, 23.925276452999956],
          [120.316565842000017, 23.925733944999966],
          [120.316433520000032, 23.925243163999976],
          [120.316398231000093, 23.925221862999969],
          [120.315852978000052, 23.925420788999968],
          [120.314819925000052, 23.926134282999989],
          [120.314423553000097, 23.926395439000022],
          [120.313754443000107, 23.926717976999981],
          [120.280023498000091, 23.936881737],
          [120.280023152000012, 23.93688184099999],
          [120.280592033000033, 23.939227877],
          [120.314946053000085, 23.929272073999964],
          [120.315200263000065, 23.929199297],
          [120.31555777800007, 23.928663232999984],
          [120.315393981000057, 23.927736606999968],
          [120.315698176000069, 23.92766640799999],
          [120.31556713800002, 23.92728733400002],
          [120.315818045000015, 23.927164347000019],
          [120.316277162, 23.927037751999972],
          [120.316471274000037, 23.927002306],
          [120.316813923000026, 23.926917908999972],
          [120.317161636000037, 23.926809881999986],
          [120.317289919000018, 23.92674236499999],
          [120.317345621000072, 23.926674847999987],
          [120.317352372000073, 23.926639400999978],
          [120.317350684000061, 23.926597203000028],
          [120.317256257000039, 23.926375324999963],
          [120.317149536000088, 23.926139900999981],
          [120.31763048600007, 23.925965614999988],
          [120.317801991999971, 23.925699752],
          [120.317853336000113, 23.925451733999957],
          [120.317956430000109, 23.925412810999973],
          [120.318239574, 23.925276452999956],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '仁愛村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-003',
      VILLAGE_ID: '003',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.318239574, 23.925276452999956],
          [120.319111936000013, 23.92485633699998],
          [120.32040854300007, 23.924027714000015],
          [120.320635819000017, 23.923815295999969],
          [120.321264272999983, 23.924119410999971],
          [120.322695648000021, 23.924371559999976],
          [120.325787429, 23.924823528999958],
          [120.328738357, 23.925295675000019],
          [120.32917220899999, 23.925032652],
          [120.329873894, 23.924751860999983],
          [120.331451274000088, 23.92438973699999],
          [120.334004396000068, 23.923945117999988],
          [120.335385429000098, 23.923714564999987],
          [120.335474328000032, 23.923714950000015],
          [120.33568131299999, 23.921536590999985],
          [120.335568963999989, 23.92156083],
          [120.334206226000092, 23.921818431],
          [120.333155412, 23.921877397999982],
          [120.332257616000092, 23.921746513999988],
          [120.330751892000052, 23.921549403000014],
          [120.330117337000019, 23.921305372999985],
          [120.32982821500002, 23.921075492999972],
          [120.329261633000101, 23.920193083999983],
          [120.329067271000099, 23.919706016999985],
          [120.32872756800009, 23.918754667000023],
          [120.328543268000089, 23.918708659999982],
          [120.328345753999983, 23.918832172999977],
          [120.32782685100004, 23.919214377999978],
          [120.327229479000039, 23.91955880499999],
          [120.326480090000018, 23.919813293999976],
          [120.325716579000087, 23.919795597999986],
          [120.32490877500004, 23.919290859999975],
          [120.324305217000074, 23.91847196299999],
          [120.323982114000046, 23.917682994999989],
          [120.323477171000036, 23.915890784999974],
          [120.323278528000074, 23.91513094799999],
          [120.32326318300008, 23.915073597999967],
          [120.323123091000042, 23.915044339000016],
          [120.323029745000085, 23.91502958],
          [120.322889356, 23.915057602999962],
          [120.322654464000038, 23.915271405999974],
          [120.321336911, 23.916883735999971],
          [120.320127678000048, 23.918654031],
          [120.320003977000042, 23.918481637999985],
          [120.319639103000085, 23.916733024999964],
          [120.31970224799997, 23.916561457999986],
          [120.319781296000087, 23.916361320000011],
          [120.319735900000069, 23.916089057],
          [120.319553165, 23.915261793999989],
          [120.319187350000107, 23.915440755],
          [120.318764292000068, 23.915800042999976],
          [120.31814250300009, 23.916596970999965],
          [120.31760715300004, 23.916981506],
          [120.317101275, 23.917082424999979],
          [120.315610178000028, 23.916949214999971],
          [120.315377866000034, 23.917116345],
          [120.316245868, 23.91928128599999],
          [120.316463358000078, 23.919503263],
          [120.316701338000016, 23.919986519000012],
          [120.316892847000048, 23.920991942999969],
          [120.316690029000029, 23.922136259999981],
          [120.316529270000046, 23.922525568],
          [120.316247003000058, 23.922772549999976],
          [120.31572353, 23.923673816],
          [120.315396031000077, 23.924297917999972],
          [120.315226378000034, 23.925017201999985],
          [120.315095695000082, 23.925496984999988],
          [120.315081150000083, 23.925672203000023],
          [120.314998504000073, 23.92584711499999],
          [120.314819925000052, 23.926134282999989],
          [120.315852978000052, 23.925420788999968],
          [120.316398231000093, 23.925221862999969],
          [120.316433520000032, 23.925243163999976],
          [120.316565842000017, 23.925733944999966],
          [120.318239574, 23.925276452999956],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '信義村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-004',
      VILLAGE_ID: '004',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.314819925000052, 23.926134282999989],
          [120.314998504000073, 23.92584711499999],
          [120.315081150000083, 23.925672203000023],
          [120.315095695000082, 23.925496984999988],
          [120.315226378000034, 23.925017201999985],
          [120.315396031000077, 23.924297917999972],
          [120.31572353, 23.923673816],
          [120.316247003000058, 23.922772549999976],
          [120.316529270000046, 23.922525568],
          [120.316690029000029, 23.922136259999981],
          [120.316892847000048, 23.920991942999969],
          [120.316701338000016, 23.919986519000012],
          [120.316463358000078, 23.919503263],
          [120.316245868, 23.91928128599999],
          [120.315377866000034, 23.917116345],
          [120.315280590000043, 23.917186327999989],
          [120.314712874000065, 23.91748456899999],
          [120.314290590000027, 23.91771482],
          [120.313981789000081, 23.917713443000011],
          [120.313359606000063, 23.917639772],
          [120.312906002000091, 23.917583355000016],
          [120.312471161000047, 23.91770833899999],
          [120.311896054000059, 23.918231685],
          [120.311262538000037, 23.91859154099999],
          [120.310690212000054, 23.918588976000017],
          [120.309822347999983, 23.918494394999964],
          [120.272040993, 23.931509547],
          [120.273963602000094, 23.932041712999965],
          [120.275464672000012, 23.932077449],
          [120.277240759000037, 23.932780012000016],
          [120.278804179000062, 23.933597400999979],
          [120.279541850000101, 23.934896981999984],
          [120.280023152000012, 23.93688184099999],
          [120.280023498000091, 23.936881737],
          [120.313754443000107, 23.926717976999981],
          [120.314423553000097, 23.926395439000022],
          [120.314819925000052, 23.926134282999989],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '後寮村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-005',
      VILLAGE_ID: '005',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.343462670000022, 23.904196420999973],
          [120.340711565000092, 23.905547425999988],
          [120.336842639, 23.907583051999985],
          [120.336917744000047, 23.907696126],
          [120.337914191000081, 23.91052286099999],
          [120.338572151000108, 23.91231986799999],
          [120.339379416000014, 23.914524589999964],
          [120.339726141, 23.915733548999963],
          [120.339759140000055, 23.916415693000015],
          [120.339643955000014, 23.917229006999978],
          [120.339164127, 23.918643862999989],
          [120.338768066000057, 23.919789738],
          [120.338433240000086, 23.920397929999972],
          [120.337674826000011, 23.92099970299999],
          [120.337044386000017, 23.921242505999974],
          [120.33568131299999, 23.921536590999985],
          [120.335474328000032, 23.923714950000015],
          [120.33604443800003, 23.923717414],
          [120.336743879000082, 23.923871811000019],
          [120.337371284000028, 23.924016444999982],
          [120.338097129000062, 23.92430415599999],
          [120.338959441000029, 23.92482825],
          [120.339946479000091, 23.925125797000014],
          [120.341149209000022, 23.925537809999966],
          [120.341954688000087, 23.925856328999988],
          [120.342580672000054, 23.926284775999981],
          [120.343022739000048, 23.926428583],
          [120.343537854000033, 23.926383482],
          [120.34402274, 23.92620578699999],
          [120.344529356000052, 23.925801094999986],
          [120.344881379000071, 23.925424139000011],
          [120.345171133999983, 23.925141531999977],
          [120.345991455000089, 23.924800622999985],
          [120.346949485000096, 23.924729006999971],
          [120.348494597999988, 23.924631487999978],
          [120.34872529499999, 23.924641752],
          [120.348992465000052, 23.924756422],
          [120.349391636000078, 23.925240647],
          [120.349524789000043, 23.925383135999976],
          [120.349564228000062, 23.925733383000019],
          [120.34966525500009, 23.926121730000027],
          [120.349880226000082, 23.926378102999973],
          [120.350208134999988, 23.92670118199997],
          [120.351199436, 23.927430232999974],
          [120.35176543, 23.927508311999979],
          [120.352343739000034, 23.927620197999975],
          [120.352375067000025, 23.927464122999979],
          [120.352940835000012, 23.925886809],
          [120.353231792000088, 23.925286431999986],
          [120.353390417000014, 23.924974268],
          [120.353864259, 23.924446852999985],
          [120.354590750000057, 23.923783598999968],
          [120.35469480499999, 23.923254659999976],
          [120.354638326000099, 23.922767125999979],
          [120.35449383600006, 23.922211541999989],
          [120.353322079, 23.917996911999957],
          [120.352849458000037, 23.91684117699997],
          [120.352184774000037, 23.914054738999983],
          [120.352186154000023, 23.913777794999969],
          [120.352110386000035, 23.912854291],
          [120.351669365000021, 23.910956896999984],
          [120.351521056000024, 23.910436258],
          [120.351384392, 23.910100557],
          [120.351296597000086, 23.910053958999967],
          [120.346436543000095, 23.911223641999964],
          [120.345367041000031, 23.907926199000013],
          [120.345366246000012, 23.907923745999987],
          [120.345275660000098, 23.907923361000012],
          [120.344572035000041, 23.908350098000017],
          [120.344461763, 23.907961940999986],
          [120.345262776000041, 23.907464221999973],
          [120.345356888000083, 23.907720719999961],
          [120.346288157, 23.907104247999978],
          [120.346075445, 23.906820632],
          [120.345356626, 23.907004511000011],
          [120.345191872000086, 23.906509744999976],
          [120.344122833000029, 23.906757032000023],
          [120.343462670000022, 23.904196420999973],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '三合村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-006',
      VILLAGE_ID: '006',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.364506822000052, 23.92147933],
          [120.36446142300008, 23.921330880000017],
          [120.364317057000108, 23.920984335],
          [120.364271637, 23.920789763999977],
          [120.364241684000035, 23.920627265999983],
          [120.364173259000054, 23.920471652],
          [120.364014765000093, 23.919870872999962],
          [120.363877708000018, 23.919602027999961],
          [120.363717417000089, 23.919368372],
          [120.363702631999971, 23.919248293999981],
          [120.364172903000025, 23.918974873],
          [120.364674678000029, 23.91866235799999],
          [120.364998165000088, 23.918536607000014],
          [120.365159978000065, 23.918459615],
          [120.365329233999987, 23.918432069999973],
          [120.365383185000042, 23.918404048999982],
          [120.365383426000108, 23.918354623000024],
          [120.365322722000073, 23.91819199],
          [120.365208761000076, 23.91791618],
          [120.365087146000064, 23.917633268000014],
          [120.364965533000031, 23.917350357000021],
          [120.364867015000073, 23.917060478999961],
          [120.364791595000028, 23.916763635999967],
          [120.364792286999986, 23.916622438999976],
          [120.364793150000082, 23.916445936999974],
          [120.364625278000048, 23.916191077999986],
          [120.364463668000099, 23.915924162999985],
          [120.36442582100004, 23.915803990000015],
          [120.364395868000074, 23.915641472999976],
          [120.364412659000095, 23.91535208099997],
          [120.364382637000048, 23.91520368799999],
          [120.364298840000046, 23.915048018999968],
          [120.36420087800002, 23.91464517699999],
          [120.364140178000071, 23.914482534999973],
          [120.36394924800004, 23.914227578999984],
          [120.363643255000042, 23.91392272],
          [120.363543983, 23.913788170000011],
          [120.363397896000023, 23.913794626000016],
          [120.363167009000094, 23.913850158],
          [120.362843809000069, 23.913919418000027],
          [120.362566627000078, 23.914010061999974],
          [120.36165581, 23.914283715999975],
          [120.361332156000017, 23.914444755000016],
          [120.361139772, 23.914486331000013],
          [120.361062972000013, 23.91447188],
          [120.361048029, 23.91440250899999],
          [120.361004236000099, 23.913929300999982],
          [120.361027956000044, 23.913795241999971],
          [120.361098529000031, 23.91351312599999],
          [120.361153796000067, 23.913216824],
          [120.36120123900001, 23.91294873399999],
          [120.361272088000078, 23.912610130999987],
          [120.36133497299997, 23.912327982999987],
          [120.361359389000071, 23.912052726999978],
          [120.361391152, 23.911871296999983],
          [120.36143866200004, 23.911589085999967],
          [120.361447355, 23.911384373000015],
          [120.361433336000019, 23.911108966],
          [120.361442343000022, 23.910840707000013],
          [120.361413054000067, 23.910544054],
          [120.361368531000039, 23.910219094],
          [120.361362161000088, 23.90995078000002],
          [120.361385988000052, 23.909795555999985],
          [120.36140981100003, 23.909640324],
          [120.361557248000054, 23.909358526999984],
          [120.36167488000001, 23.90907094399999],
          [120.361868330000107, 23.908810520000021],
          [120.362023175000104, 23.908585231],
          [120.362201356000014, 23.90830355199999],
          [120.362394631000029, 23.908078422],
          [120.362633818000063, 23.907895848],
          [120.362896237000086, 23.907678063999963],
          [120.362989169, 23.90753724099999],
          [120.363066591, 23.907424595],
          [120.363074970000085, 23.907283419999981],
          [120.36306035599999, 23.907128037999986],
          [120.362999938000016, 23.906908918],
          [120.362897487000069, 23.906815580999982],
          [120.362812935000065, 23.906815230999982],
          [120.362590025000031, 23.906814306999966],
          [120.36219032200006, 23.906812659000011],
          [120.362029113000062, 23.90676963399999],
          [120.361637790000017, 23.906626808999974],
          [120.361238751000073, 23.906491012999968],
          [120.360732132000081, 23.906347697999976],
          [120.360532665000051, 23.906269208],
          [120.360456354999982, 23.906155924999986],
          [120.360495553000078, 23.906000757],
          [120.360627483, 23.905755843999984],
          [120.360759472000026, 23.905488095999988],
          [120.360937548000038, 23.905227608999986],
          [120.360999768000056, 23.90507958799996],
          [120.361108872000045, 23.90477644899999],
          [120.36124872100001, 23.904473436999975],
          [120.361319219000052, 23.904205423999972],
          [120.361382132000031, 23.90391621499997],
          [120.36138938900001, 23.903820656999962],
          [120.361406787000064, 23.903591532999979],
          [120.361426023000021, 23.902710378999966],
          [120.361442820000093, 23.902420978999984],
          [120.361482741000032, 23.902117534999977],
          [120.361482838000029, 23.902117173000011],
          [120.361639313000069, 23.901539241],
          [120.361740656000038, 23.90125018199999],
          [120.361864989000054, 23.900975349],
          [120.36194320199999, 23.900700314999984],
          [120.361970852000013, 23.900556879],
          [120.361982640000051, 23.900495729999978],
          [120.36192935699999, 23.900389594999957],
          [120.36184480900009, 23.900389244999982],
          [120.361245078000024, 23.90042913],
          [120.360261176000094, 23.900439171],
          [120.359961276000021, 23.900466158000018],
          [120.359630491000061, 23.900521269],
          [120.358945935000065, 23.90061727],
          [120.358523022000071, 23.900650810999974],
          [120.358140780000113, 23.900680404],
          [120.358106058000089, 23.900686055999966],
          [120.357932620000028, 23.900685332],
          [120.35776863500007, 23.900684647999963],
          [120.357534869999981, 23.90067367599999],
          [120.357301693000053, 23.900724747000019],
          [120.356986821000078, 23.90074656299997],
          [120.356961440000077, 23.900786936],
          [120.356904612000108, 23.900821398],
          [120.356627482000022, 23.900849150999971],
          [120.355999863000079, 23.900886125999975],
          [120.355684935, 23.900919498],
          [120.355332378000071, 23.900923808999988],
          [120.354954553000084, 23.900945357],
          [120.354582794000052, 23.901013197999969],
          [120.354072314000064, 23.90112671099999],
          [120.35374464700007, 23.901188937000011],
          [120.353544354000064, 23.90095679099999],
          [120.353418997000048, 23.900846404999974],
          [120.353312556000105, 23.900730301],
          [120.353231468000089, 23.900579622],
          [120.35323825899999, 23.90038988100002],
          [120.353199746000058, 23.900434517],
          [120.350949072000049, 23.901254319000017],
          [120.344896501000093, 23.903492299999961],
          [120.343462670000022, 23.904196420999973],
          [120.344122833000029, 23.906757032000023],
          [120.345191872000086, 23.906509744999976],
          [120.345356626, 23.907004511000011],
          [120.346075445, 23.906820632],
          [120.346288157, 23.907104247999978],
          [120.345356888000083, 23.907720719999961],
          [120.345262776000041, 23.907464221999973],
          [120.344461763, 23.907961940999986],
          [120.344572035000041, 23.908350098000017],
          [120.345275660000098, 23.907923361000012],
          [120.345366246000012, 23.907923745999987],
          [120.345367041000031, 23.907926199000013],
          [120.346436543000095, 23.911223641999964],
          [120.351296597000086, 23.910053958999967],
          [120.351384392, 23.910100557],
          [120.351521056000024, 23.910436258],
          [120.351669365000021, 23.910956896999984],
          [120.352110386000035, 23.912854291],
          [120.352186154000023, 23.913777794999969],
          [120.352184774000037, 23.914054738999983],
          [120.352849458000037, 23.91684117699997],
          [120.353322079, 23.917996911999957],
          [120.35449383600006, 23.922211541999989],
          [120.354638326000099, 23.922767125999979],
          [120.35469480499999, 23.923254659999976],
          [120.354590750000057, 23.923783598999968],
          [120.353864259, 23.924446852999985],
          [120.353390417000014, 23.924974268],
          [120.353231792000088, 23.925286431999986],
          [120.352940835000012, 23.925886809],
          [120.352375067000025, 23.927464122999979],
          [120.352343739000034, 23.927620197999975],
          [120.353274899000098, 23.927657154],
          [120.3537101820001, 23.927623713999974],
          [120.354005161000032, 23.927495617000019],
          [120.354378319000034, 23.92708564699999],
          [120.355943049000061, 23.926386718999982],
          [120.356430506000038, 23.926153595],
          [120.356675165000055, 23.92584891000001],
          [120.356676563000065, 23.925566713999988],
          [120.356742232000073, 23.925226000999988],
          [120.356846355000016, 23.924873696000013],
          [120.356796449000072, 23.924614801999983],
          [120.35672446, 23.924136317000023],
          [120.356727662000011, 23.923489634],
          [120.356653976000089, 23.922866135999975],
          [120.356350527999979, 23.92212410199999],
          [120.356007816000115, 23.92155827399999],
          [120.355944653000051, 23.92139339200002],
          [120.356482682000077, 23.921278061],
          [120.358787263000067, 23.921040772000019],
          [120.359299121000049, 23.921042906000011],
          [120.359707563000043, 23.921256259],
          [120.360001190000048, 23.921398581999973],
          [120.360222729000029, 23.92138045],
          [120.360400451000032, 23.921072093999989],
          [120.360577085000045, 23.920984523],
          [120.360753430000045, 23.920955820999982],
          [120.361009027000023, 23.921096703999972],
          [120.361647222000116, 23.921614507999976],
          [120.361870865000014, 23.921740543999977],
          [120.362262983000051, 23.921808398999964],
          [120.362710848999981, 23.921942729],
          [120.362935035000092, 23.921958371999985],
          [120.36330384900009, 23.92187895],
          [120.363568799000063, 23.921747583999988],
          [120.364506822000052, 23.92147933],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '永興村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-007',
      VILLAGE_ID: '007',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.333930783000028, 23.95343546299999],
          [120.333263978000105, 23.952041915999978],
          [120.337027581000029, 23.951285991],
          [120.342927099999983, 23.950459159999962],
          [120.342974062000053, 23.950202639999976],
          [120.343072795, 23.949890694000025],
          [120.343424851999984, 23.94903073],
          [120.343985877, 23.947573223],
          [120.344409585000108, 23.94549024199999],
          [120.344661797000029, 23.94484335299999],
          [120.34476945300004, 23.944062447],
          [120.344986038, 23.942252885000013],
          [120.345332067000072, 23.939884257],
          [120.344748642000013, 23.939677717999967],
          [120.343328478000117, 23.939330862],
          [120.342911975000106, 23.939172895999977],
          [120.342388574000097, 23.93875887],
          [120.341714883999984, 23.93750643799999],
          [120.340868847000024, 23.935649001999977],
          [120.340791723000038, 23.93562026499999],
          [120.34040376400003, 23.935930986],
          [120.339255253000047, 23.936877415],
          [120.339006957000024, 23.93707513899999],
          [120.337953477000042, 23.93756757899999],
          [120.3366374000001, 23.938030480999974],
          [120.336209727000082, 23.938132848],
          [120.335931604000038, 23.938117454],
          [120.33577800800002, 23.937932200000024],
          [120.335765669999986, 23.937321567],
          [120.335765480000063, 23.934339700999985],
          [120.335727318000067, 23.932740478],
          [120.335698007000019, 23.932427964999977],
          [120.335621745000026, 23.932228851999955],
          [120.335529671000018, 23.932100656999967],
          [120.333287609000052, 23.932318133],
          [120.331060991000058, 23.932535643999962],
          [120.330833258000084, 23.932511544000015],
          [120.330040262000026, 23.932463235999982],
          [120.32977173800009, 23.93247328],
          [120.329686078999956, 23.932517759999985],
          [120.328598348, 23.932826954999975],
          [120.326349470000096, 23.933478638999961],
          [120.325103083000059, 23.933787115000023],
          [120.323534324000093, 23.9340685],
          [120.323234276000093, 23.934265658],
          [120.322171991, 23.935014100999958],
          [120.321745235000094, 23.93526961000001],
          [120.321423179, 23.935344453],
          [120.32069625500003, 23.93545563199999],
          [120.31867181699999, 23.935631832],
          [120.280464052000056, 23.948921015999961],
          [120.280463828000023, 23.94892109399999],
          [120.281026153000084, 23.950415346999986],
          [120.281626086000074, 23.952461685999989],
          [120.282826390000068, 23.954508391999951],
          [120.284014373000105, 23.955785051999982],
          [120.285114984000046, 23.956567401000012],
          [120.286140597000085, 23.957108396000013],
          [120.287491465000016, 23.957350829],
          [120.288817376000011, 23.957593215000017],
          [120.290255749000025, 23.958226404],
          [120.291256088000068, 23.959571829000016],
          [120.291843784000065, 23.960468707],
          [120.293507086000048, 23.962101891000032],
          [120.29462009699999, 23.963217541999985],
          [120.296621150000064, 23.964724562999987],
          [120.298747227000035, 23.966381128000016],
          [120.301136045000021, 23.96799181099998],
          [120.303124597000036, 23.96934941300001],
          [120.304715992000027, 23.970544467000014],
          [120.320828779000067, 23.961573974000011],
          [120.323763371000013, 23.959923127],
          [120.327927957000043, 23.957641319999979],
          [120.32976885100004, 23.956633172999982],
          [120.331371683000043, 23.955762236999984],
          [120.331926660000036, 23.955369592999986],
          [120.33205007299999, 23.95526431],
          [120.332050581000104, 23.955165551999965],
          [120.331860339000045, 23.954826093999973],
          [120.331448549000015, 23.95425993199999],
          [120.331464597000036, 23.954125962000017],
          [120.331518685000091, 23.954062706999967],
          [120.331734150000074, 23.95397898599996],
          [120.333833486, 23.953437847000014],
          [120.333930783000028, 23.95343546299999],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '五俊村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-008',
      VILLAGE_ID: '008',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.354538538000028, 23.942343220999984],
          [120.355001227, 23.942290929999988],
          [120.357075041000016, 23.941745845999989],
          [120.35752466100007, 23.941463736],
          [120.357695737000071, 23.941251464999969],
          [120.357667495000101, 23.940711770999986],
          [120.357039515000011, 23.939558986999977],
          [120.356160242000101, 23.938221494999986],
          [120.355724450000025, 23.937531299999964],
          [120.355023380000034, 23.936499784000013],
          [120.354663814000105, 23.93563956500002],
          [120.354578923000048, 23.935190943999984],
          [120.354620295000018, 23.933878337999978],
          [120.354501981000013, 23.93314141],
          [120.354346913000057, 23.93278855499999],
          [120.352355352000018, 23.930328619],
          [120.352040151000111, 23.92990617],
          [120.352041606000057, 23.929614641999965],
          [120.352064334000033, 23.928994444],
          [120.352343739000034, 23.927620197999975],
          [120.35176543, 23.927508311999979],
          [120.351199436, 23.927430232999974],
          [120.350208134999988, 23.92670118199997],
          [120.349880226000082, 23.926378102999973],
          [120.34966525500009, 23.926121730000027],
          [120.349564228000062, 23.925733383000019],
          [120.349524789000043, 23.925383135999976],
          [120.349391636000078, 23.925240647],
          [120.348992465000052, 23.924756422],
          [120.34872529499999, 23.924641752],
          [120.348494597999988, 23.924631487999978],
          [120.346949485000096, 23.924729006999971],
          [120.345991455000089, 23.924800622999985],
          [120.345171133999983, 23.925141531999977],
          [120.344881379000071, 23.925424139000011],
          [120.344529356000052, 23.925801094999986],
          [120.34402274, 23.92620578699999],
          [120.343537854000033, 23.926383482],
          [120.343022739000048, 23.926428583],
          [120.342580672000054, 23.926284775999981],
          [120.341954688000087, 23.925856328999988],
          [120.341149209000022, 23.925537809999966],
          [120.339946479000091, 23.925125797000014],
          [120.338959441000029, 23.92482825],
          [120.338097129000062, 23.92430415599999],
          [120.337371284000028, 23.924016444999982],
          [120.336743879000082, 23.923871811000019],
          [120.33604443800003, 23.923717414],
          [120.335474328000032, 23.923714950000015],
          [120.335385429000098, 23.923714564999987],
          [120.334004396000068, 23.923945117999988],
          [120.331451274000088, 23.92438973699999],
          [120.329873894, 23.924751860999983],
          [120.32917220899999, 23.925032652],
          [120.328738357, 23.925295675000019],
          [120.328209974000046, 23.925917823],
          [120.327376164000029, 23.927254504999986],
          [120.326648431000066, 23.928585392999977],
          [120.326419768000051, 23.928991234],
          [120.325850066000044, 23.929632116999958],
          [120.324820509, 23.931020959999987],
          [120.32366372700001, 23.93277724499999],
          [120.322171991, 23.935014100999958],
          [120.323234276000093, 23.934265658],
          [120.323534324000093, 23.9340685],
          [120.325103083000059, 23.933787115000023],
          [120.326349470000096, 23.933478638999961],
          [120.328598348, 23.932826954999975],
          [120.329686078999956, 23.932517759999985],
          [120.32977173800009, 23.93247328],
          [120.330040262000026, 23.932463235999982],
          [120.330833258000084, 23.932511544000015],
          [120.331060991000058, 23.932535643999962],
          [120.333287609000052, 23.932318133],
          [120.335529671000018, 23.932100656999967],
          [120.335621745000026, 23.932228851999955],
          [120.335698007000019, 23.932427964999977],
          [120.335727318000067, 23.932740478],
          [120.335765480000063, 23.934339700999985],
          [120.335765669999986, 23.937321567],
          [120.33577800800002, 23.937932200000024],
          [120.335931604000038, 23.938117454],
          [120.336209727000082, 23.938132848],
          [120.3366374000001, 23.938030480999974],
          [120.337953477000042, 23.93756757899999],
          [120.339006957000024, 23.93707513899999],
          [120.339255253000047, 23.936877415],
          [120.34040376400003, 23.935930986],
          [120.340791723000038, 23.93562026499999],
          [120.340868847000024, 23.935649001999977],
          [120.341714883999984, 23.93750643799999],
          [120.342388574000097, 23.93875887],
          [120.342911975000106, 23.939172895999977],
          [120.343328478000117, 23.939330862],
          [120.344748642000013, 23.939677717999967],
          [120.345332067000072, 23.939884257],
          [120.345643480000035, 23.939993919],
          [120.347611405000066, 23.940972568],
          [120.35039007500005, 23.94165170699999],
          [120.353184709000047, 23.942231482],
          [120.354274379, 23.942373075000027],
          [120.354538538000028, 23.942343220999984],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '路上村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-009',
      VILLAGE_ID: '009',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.335321396000012, 23.903334365000024],
          [120.335743406999981, 23.903343426999957],
          [120.33612532700009, 23.903321709],
          [120.336380553000012, 23.90319412299997],
          [120.336599398000089, 23.90272716499997],
          [120.336744180000096, 23.901791929],
          [120.336669216000018, 23.901522603999958],
          [120.33624407800005, 23.900538345000019],
          [120.335958699, 23.899603860999981],
          [120.335130738000046, 23.897585525],
          [120.335051126000053, 23.897407434999977],
          [120.334749510000051, 23.896335029999978],
          [120.334282162, 23.895191256000022],
          [120.334153064, 23.89507104],
          [120.333934369000048, 23.894669910999976],
          [120.333903774000078, 23.894617786000012],
          [120.333847117, 23.894553197999965],
          [120.333769251000021, 23.89448528699999],
          [120.333724739000104, 23.89442402000002],
          [120.333655811000057, 23.894302138999969],
          [120.333488550000084, 23.89375116],
          [120.333476251000079, 23.893667529],
          [120.33338224500001, 23.89331066399999],
          [120.333350185000072, 23.893473223999987],
          [120.333287143999982, 23.89358779599999],
          [120.332699738000059, 23.89446574],
          [120.332709507, 23.894590198999978],
          [120.332617382000052, 23.894963520000026],
          [120.330412483000018, 23.895412823999976],
          [120.329097508, 23.895691777],
          [120.328519988000039, 23.89581428599999],
          [120.325603605000055, 23.896430332000016],
          [120.323463316000016, 23.897049453000015],
          [120.322028259000049, 23.89753247499997],
          [120.321221945000033, 23.895462779],
          [120.320669197000043, 23.894051586999957],
          [120.319537110000041, 23.894443931],
          [120.318932044999983, 23.893646559999972],
          [120.319084638000035, 23.894523202],
          [120.319802200000012, 23.89636860400002],
          [120.320464423000075, 23.897509409999987],
          [120.32075758200007, 23.897817761999967],
          [120.321004030000026, 23.897980092],
          [120.321527245000084, 23.899418318999984],
          [120.323811098000064, 23.905388703],
          [120.329818014, 23.903551443],
          [120.330188720999985, 23.90352544],
          [120.3308477920001, 23.903741104],
          [120.331235394, 23.903921329999985],
          [120.331567152000034, 23.904014934000017],
          [120.331780195000064, 23.90401586],
          [120.332332843000017, 23.903805124000023],
          [120.334286218000102, 23.903302643],
          [120.335094206, 23.903328939],
          [120.335321396000012, 23.903334365000024],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '路平村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-010',
      VILLAGE_ID: '010',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.343462670000022, 23.904196420999973],
          [120.344896501000093, 23.903492299999961],
          [120.350949072000049, 23.901254319000017],
          [120.353199746000058, 23.900434517],
          [120.35323825899999, 23.90038988100002],
          [120.353253405, 23.899966751000015],
          [120.353355641, 23.899680274999959],
          [120.353432132000066, 23.899489762000012],
          [120.353527277000026, 23.89934559300001],
          [120.353464731000031, 23.89926438199999],
          [120.353446794000092, 23.89907348199999],
          [120.353447716000019, 23.898888439],
          [120.353505091000102, 23.89874411200001],
          [120.353625904000069, 23.898501748999969],
          [120.353649205, 23.898257514000015],
          [120.353640464, 23.898168592999959],
          [120.353651241000065, 23.897615629000018],
          [120.353687562, 23.896981121],
          [120.35373807500001, 23.896895780000012],
          [120.354045282000016, 23.896306319],
          [120.354468947000072, 23.895543223999979],
          [120.353871216000016, 23.895733563],
          [120.35322476500005, 23.895933139],
          [120.352650672000095, 23.896112746000021],
          [120.35201396, 23.896319148000025],
          [120.351496561000076, 23.896481653],
          [120.351092557000015, 23.89660996199999],
          [120.350531277000087, 23.896785688],
          [120.350009587000045, 23.896950815000018],
          [120.349588575000098, 23.897078641999986],
          [120.349571287, 23.896395765],
          [120.349558059000046, 23.895990128999976],
          [120.349527779000027, 23.895061617999986],
          [120.349502738000069, 23.894192016000019],
          [120.34952953100003, 23.894124617999967],
          [120.349533034000061, 23.89401184699999],
          [120.349578261000033, 23.893785222],
          [120.348987822000012, 23.893701722999989],
          [120.343448772000102, 23.893210193],
          [120.337915132000035, 23.892680585999976],
          [120.3374718, 23.892618626999976],
          [120.334524281000085, 23.89183035],
          [120.334481451000087, 23.891817977],
          [120.334389466000033, 23.891755026999974],
          [120.334427130000094, 23.891842240999978],
          [120.334435416, 23.891903001999971],
          [120.33443725700009, 23.892290583000015],
          [120.334479159000011, 23.892668969999967],
          [120.333890509000071, 23.892881015999976],
          [120.333866886999971, 23.892895779999979],
          [120.333856553000032, 23.89291349599999],
          [120.33388608000007, 23.893084015999975],
          [120.333880913000016, 23.89310542299999],
          [120.333858767000024, 23.893119448999972],
          [120.33338224500001, 23.89331066399999],
          [120.333476251000079, 23.893667529],
          [120.333488550000084, 23.89375116],
          [120.333655811000057, 23.894302138999969],
          [120.333724739000104, 23.89442402000002],
          [120.333769251000021, 23.89448528699999],
          [120.333847117, 23.894553197999965],
          [120.333903774000078, 23.894617786000012],
          [120.333934369000048, 23.894669910999976],
          [120.334153064, 23.89507104],
          [120.334282162, 23.895191256000022],
          [120.334749510000051, 23.896335029999978],
          [120.335051126000053, 23.897407434999977],
          [120.335130738000046, 23.897585525],
          [120.335958699, 23.899603860999981],
          [120.33624407800005, 23.900538345000019],
          [120.336669216000018, 23.901522603999958],
          [120.336744180000096, 23.901791929],
          [120.336599398000089, 23.90272716499997],
          [120.336380553000012, 23.90319412299997],
          [120.33612532700009, 23.903321709],
          [120.335743406999981, 23.903343426999957],
          [120.335321396000012, 23.903334365000024],
          [120.335710587000094, 23.904376469999978],
          [120.33592561, 23.905176063999971],
          [120.33610576500007, 23.906418341999988],
          [120.336264246000027, 23.907052081999979],
          [120.33648375100006, 23.90747136300001],
          [120.336680815000037, 23.907582353999985],
          [120.336842639, 23.907583051999985],
          [120.340711565000092, 23.905547425999988],
          [120.343462670000022, 23.904196420999973],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '三成村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-011',
      VILLAGE_ID: '011',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.343585419000078, 23.877668686999975],
          [120.343401283000034, 23.877712271999979],
          [120.342646134999981, 23.87789247],
          [120.341920468000026, 23.878071382],
          [120.341465147999969, 23.878181523999988],
          [120.340622030000063, 23.878381815],
          [120.339846853000026, 23.87857414],
          [120.339442654000109, 23.878664124999975],
          [120.339272572000027, 23.878044263999978],
          [120.339178886000013, 23.877709614],
          [120.338602022000032, 23.877842459],
          [120.336959745000058, 23.878212872999971],
          [120.335541389000028, 23.878539585999967],
          [120.334895728000092, 23.878687856999978],
          [120.33488811800008, 23.878441225],
          [120.334868235000044, 23.87842483199999],
          [120.334757187000022, 23.878450843999978],
          [120.334444060999985, 23.87851674],
          [120.334268585, 23.87856083099999],
          [120.334264703000017, 23.878452796000026],
          [120.334244790000071, 23.878442515999986],
          [120.334160401000062, 23.87846049],
          [120.33354093199999, 23.87856785799999],
          [120.333136093, 23.87864353899997],
          [120.333001479, 23.878668705999971],
          [120.333046855000021, 23.878827504],
          [120.332884087999986, 23.878880163999987],
          [120.332870337000045, 23.878823641999968],
          [120.332313582000083, 23.87899889800001],
          [120.331742195000047, 23.879177346],
          [120.331405276000069, 23.879283712],
          [120.330829333, 23.87946433199998],
          [120.33086659500006, 23.879642930999971],
          [120.33065392900005, 23.879524968999974],
          [120.33028371500005, 23.879318456000011],
          [120.329980019000018, 23.879365793000026],
          [120.329664733000058, 23.879163220999978],
          [120.329197280000031, 23.878880633999962],
          [120.328929040000034, 23.878715078],
          [120.328185125000019, 23.878257576999985],
          [120.328153074000042, 23.878236742],
          [120.328176574000054, 23.87835651],
          [120.32760324100002, 23.87852979799997],
          [120.326916156000038, 23.878735930999984],
          [120.326626258000019, 23.878824775999981],
          [120.326457159000029, 23.878875738000016],
          [120.326362691000085, 23.878872949],
          [120.326254040000094, 23.878739518000014],
          [120.32615786300002, 23.878628541],
          [120.32610484000007, 23.878620914],
          [120.325835097000081, 23.878544393],
          [120.325765084000068, 23.878402272],
          [120.325637965000055, 23.87841944],
          [120.32560094499999, 23.87842666300001],
          [120.32550120000009, 23.878436565],
          [120.325460925000016, 23.878451159999972],
          [120.325440044000047, 23.878446635999957],
          [120.32541758, 23.878437678999987],
          [120.325353240000013, 23.878441821999989],
          [120.325269512000062, 23.87846361299999],
          [120.325253609000015, 23.878429574999963],
          [120.32509192100008, 23.87784307499998],
          [120.325091561999983, 23.87784315299999],
          [120.324457647000017, 23.877985046999974],
          [120.324298628000051, 23.878021134999972],
          [120.323852540000075, 23.878152132000015],
          [120.324063251000069, 23.8787583],
          [120.324240888000062, 23.879268395999965],
          [120.324153936000016, 23.879291652999971],
          [120.323979521000069, 23.87881815799999],
          [120.323399672000065, 23.87900617299999],
          [120.323066718000049, 23.879117124],
          [120.323172819000092, 23.879430780999979],
          [120.323252281999984, 23.879664293],
          [120.3226837630001, 23.879837584000018],
          [120.322246165000024, 23.879971955],
          [120.32233967099999, 23.880233836999984],
          [120.322541157000032, 23.88079876599999],
          [120.322600124, 23.88096858599998],
          [120.322096052999981, 23.881115556999976],
          [120.321679493000033, 23.881236827],
          [120.321825375, 23.881630425000019],
          [120.322022001000036, 23.882183477999973],
          [120.322131728000031, 23.882492319999969],
          [120.32149554100009, 23.882687465999979],
          [120.321172446000091, 23.882788640999976],
          [120.321281870999982, 23.88308161799999],
          [120.321470561000055, 23.883610952000016],
          [120.321691098000073, 23.88422618700001],
          [120.32191955100005, 23.884857799000013],
          [120.321933826000077, 23.884915261999982],
          [120.324405978000058, 23.886017045000013],
          [120.329173339999983, 23.887971150999988],
          [120.330980395000083, 23.888754231999986],
          [120.332153395000091, 23.889371842999971],
          [120.332765821000081, 23.889699897],
          [120.3330251000001, 23.889882863000011],
          [120.333107190000064, 23.890112911],
          [120.333230769, 23.890371850999987],
          [120.333519558000035, 23.890889912000024],
          [120.333736618000074, 23.891187537999986],
          [120.333943660000045, 23.891408558],
          [120.334192682000079, 23.89156276400001],
          [120.33432735800001, 23.891687763999961],
          [120.334389466000033, 23.891755026999974],
          [120.334481451000087, 23.891817977],
          [120.334524281000085, 23.89183035],
          [120.3374718, 23.892618626999976],
          [120.337915132000035, 23.892680585999976],
          [120.343448772000102, 23.893210193],
          [120.348987822000012, 23.893701722999989],
          [120.348994376000064, 23.893566734999968],
          [120.349042561000019, 23.892963230000017],
          [120.349068629000044, 23.89260965399999],
          [120.349584689999986, 23.892399837000021],
          [120.350004195, 23.892233348999969],
          [120.349916951000068, 23.892048087000024],
          [120.349724686000073, 23.891624901999968],
          [120.349592986000047, 23.891349907999981],
          [120.349496846000079, 23.89114003],
          [120.349393314000039, 23.89091295699999],
          [120.349295039000012, 23.890691629999989],
          [120.349182215000042, 23.890454205],
          [120.349076800000034, 23.890230563999971],
          [120.348934053000107, 23.889922864000013],
          [120.348804615000063, 23.889644168],
          [120.348667649000063, 23.889348754000018],
          [120.348519688999986, 23.889037366],
          [120.348475324000091, 23.888939317999967],
          [120.348343628000066, 23.888659438999973],
          [120.348101040000074, 23.88812819199999],
          [120.347971574000113, 23.887856357000018],
          [120.347819980000054, 23.887524338999974],
          [120.347745651000082, 23.887363067],
          [120.34757184800003, 23.88698802899999],
          [120.347480836000045, 23.886781982999977],
          [120.347338427000082, 23.886482635999968],
          [120.347236738000106, 23.886262429999967],
          [120.34714070599999, 23.886053382999965],
          [120.347029323, 23.885807510999985],
          [120.346882582000035, 23.885494519],
          [120.346707087000027, 23.885144828],
          [120.346667879000037, 23.885028355],
          [120.34636953800009, 23.884386791999972],
          [120.346190478000025, 23.884027124999982],
          [120.346051060000022, 23.88369754],
          [120.345979333000045, 23.88357427399999],
          [120.34537535700008, 23.883640698999983],
          [120.345371701000062, 23.88362437599999],
          [120.345024575000025, 23.882428348],
          [120.344754749, 23.881581991999987],
          [120.344565064000108, 23.88099864899997],
          [120.344216354000082, 23.880119685],
          [120.344073749, 23.879750384000026],
          [120.344034144000034, 23.879583298999975],
          [120.343964256000035, 23.879118451999979],
          [120.34382251, 23.878579554999966],
          [120.343633541000045, 23.87785612399998],
          [120.343585419000078, 23.877668686999975],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '福榮村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-012',
      VILLAGE_ID: '012',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.33338224500001, 23.89331066399999],
          [120.333858767000024, 23.893119448999972],
          [120.333880913000016, 23.89310542299999],
          [120.33388608000007, 23.893084015999975],
          [120.333856553000032, 23.89291349599999],
          [120.333866886999971, 23.892895779999979],
          [120.333890509000071, 23.892881015999976],
          [120.334479159000011, 23.892668969999967],
          [120.33443725700009, 23.892290583000015],
          [120.334435416, 23.891903001999971],
          [120.334427130000094, 23.891842240999978],
          [120.334389466000033, 23.891755026999974],
          [120.33432735800001, 23.891687763999961],
          [120.334192682000079, 23.89156276400001],
          [120.333943660000045, 23.891408558],
          [120.333736618000074, 23.891187537999986],
          [120.333519558000035, 23.890889912000024],
          [120.333230769, 23.890371850999987],
          [120.333107190000064, 23.890112911],
          [120.3330251000001, 23.889882863000011],
          [120.332765821000081, 23.889699897],
          [120.332153395000091, 23.889371842999971],
          [120.330980395000083, 23.888754231999986],
          [120.329173339999983, 23.887971150999988],
          [120.324405978000058, 23.886017045000013],
          [120.321933826000077, 23.884915261999982],
          [120.321737194000079, 23.885001553999967],
          [120.321514211999968, 23.88489864],
          [120.321112334000063, 23.884723306],
          [120.320711244000094, 23.884547217000016],
          [120.320901526000043, 23.885060676000013],
          [120.320961733000104, 23.885239324999979],
          [120.321091681000098, 23.885604789],
          [120.321272559000022, 23.88611040499999],
          [120.321511875000041, 23.886780358999982],
          [120.321724413000084, 23.887383756999988],
          [120.321906950000056, 23.887894065999976],
          [120.321968808000051, 23.88805831899997],
          [120.322202102999967, 23.888723947999985],
          [120.322993360000055, 23.888492010999965],
          [120.323843056000101, 23.888243514],
          [120.323974485999983, 23.888635574000016],
          [120.324119340000038, 23.889062960999969],
          [120.323487939000088, 23.889259615999986],
          [120.322703999000026, 23.889511263000013],
          [120.32185404599997, 23.889779571000016],
          [120.320904384000073, 23.89007907299996],
          [120.320265611000067, 23.890277795],
          [120.319801704000028, 23.890424944000014],
          [120.319046822999979, 23.890657034999982],
          [120.318710160000023, 23.890764852999983],
          [120.318404716000018, 23.890860393],
          [120.318590482000104, 23.891314737999984],
          [120.318711571000108, 23.891631038],
          [120.318736736, 23.891738993999958],
          [120.318906292000051, 23.892249239999984],
          [120.318935948000103, 23.892420728999976],
          [120.318964219, 23.892549385999963],
          [120.319002018000091, 23.89271911399997],
          [120.319009098000038, 23.892902321999976],
          [120.318999193000053, 23.892951018000012],
          [120.318998326000042, 23.893116467000024],
          [120.318984858, 23.893229995],
          [120.318972253000069, 23.893486984999964],
          [120.318877553000064, 23.893515423999979],
          [120.318932044999983, 23.893646559999972],
          [120.319537110000041, 23.894443931],
          [120.320669197000043, 23.894051586999957],
          [120.321221945000033, 23.895462779],
          [120.322028259000049, 23.89753247499997],
          [120.323463316000016, 23.897049453000015],
          [120.325603605000055, 23.896430332000016],
          [120.328519988000039, 23.89581428599999],
          [120.329097508, 23.895691777],
          [120.330412483000018, 23.895412823999976],
          [120.332617382000052, 23.894963520000026],
          [120.332709507, 23.894590198999978],
          [120.332699738000059, 23.89446574],
          [120.333287143999982, 23.89358779599999],
          [120.333350185000072, 23.893473223999987],
          [120.33338224500001, 23.89331066399999],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '頂廍村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-013',
      VILLAGE_ID: '013',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.33568131299999, 23.921536590999985],
          [120.337044386000017, 23.921242505999974],
          [120.337674826000011, 23.92099970299999],
          [120.338433240000086, 23.920397929999972],
          [120.338768066000057, 23.919789738],
          [120.339164127, 23.918643862999989],
          [120.339643955000014, 23.917229006999978],
          [120.339759140000055, 23.916415693000015],
          [120.339726141, 23.915733548999963],
          [120.339379416000014, 23.914524589999964],
          [120.338572151000108, 23.91231986799999],
          [120.337914191000081, 23.91052286099999],
          [120.336917744000047, 23.907696126],
          [120.336842639, 23.907583051999985],
          [120.336680815000037, 23.907582353999985],
          [120.33648375100006, 23.90747136300001],
          [120.336264246000027, 23.907052081999979],
          [120.33610576500007, 23.906418341999988],
          [120.33592561, 23.905176063999971],
          [120.335710587000094, 23.904376469999978],
          [120.335321396000012, 23.903334365000024],
          [120.335094206, 23.903328939],
          [120.334286218000102, 23.903302643],
          [120.332332843000017, 23.903805124000023],
          [120.331780195000064, 23.90401586],
          [120.331567152000034, 23.904014934000017],
          [120.331235394, 23.903921329999985],
          [120.3308477920001, 23.903741104],
          [120.330188720999985, 23.90352544],
          [120.329818014, 23.903551443],
          [120.323811098000064, 23.905388703],
          [120.323711598000045, 23.905499426999988],
          [120.323051075000066, 23.905648063999973],
          [120.322688110000058, 23.90566671399999],
          [120.322216099, 23.905492842999973],
          [120.321360154000089, 23.905155582],
          [120.320843828000079, 23.90507248399999],
          [120.320552746000075, 23.90510108699997],
          [120.320277482000023, 23.905180689000012],
          [120.320001419000036, 23.90539169700002],
          [120.319527195000092, 23.905662456999988],
          [120.319240649000108, 23.905792540999958],
          [120.318579956, 23.905951310000027],
          [120.318139464000069, 23.906090805999987],
          [120.318051023000066, 23.906171232],
          [120.317883889000086, 23.90659494899999],
          [120.317781463000088, 23.907241218],
          [120.317678561000093, 23.907998647999971],
          [120.317624007000063, 23.909639855999988],
          [120.317687128000102, 23.910185794000011],
          [120.31783391799999, 23.91120425599999],
          [120.318386755999981, 23.91285763199998],
          [120.31869432800012, 23.913091128999987],
          [120.319442393000017, 23.914977558],
          [120.319553165, 23.915261793999989],
          [120.319735900000069, 23.916089057],
          [120.319781296000087, 23.916361320000011],
          [120.31970224799997, 23.916561457999986],
          [120.319639103000085, 23.916733024999964],
          [120.320003977000042, 23.918481637999985],
          [120.320127678000048, 23.918654031],
          [120.321336911, 23.916883735999971],
          [120.322654464000038, 23.915271405999974],
          [120.322889356, 23.915057602999962],
          [120.323029745000085, 23.91502958],
          [120.323123091000042, 23.915044339000016],
          [120.32326318300008, 23.915073597999967],
          [120.323278528000074, 23.91513094799999],
          [120.323477171000036, 23.915890784999974],
          [120.323982114000046, 23.917682994999989],
          [120.324305217000074, 23.91847196299999],
          [120.32490877500004, 23.919290859999975],
          [120.325716579000087, 23.919795597999986],
          [120.326480090000018, 23.919813293999976],
          [120.327229479000039, 23.91955880499999],
          [120.32782685100004, 23.919214377999978],
          [120.328345753999983, 23.918832172999977],
          [120.328543268000089, 23.918708659999982],
          [120.32872756800009, 23.918754667000023],
          [120.329067271000099, 23.919706016999985],
          [120.329261633000101, 23.920193083999983],
          [120.32982821500002, 23.921075492999972],
          [120.330117337000019, 23.921305372999985],
          [120.330751892000052, 23.921549403000014],
          [120.332257616000092, 23.921746513999988],
          [120.333155412, 23.921877397999982],
          [120.334206226000092, 23.921818431],
          [120.335568963999989, 23.92156083],
          [120.33568131299999, 23.921536590999985],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '新街村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-014',
      VILLAGE_ID: '014',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.315377866000034, 23.917116345],
          [120.315610178000028, 23.916949214999971],
          [120.317101275, 23.917082424999979],
          [120.31760715300004, 23.916981506],
          [120.31814250300009, 23.916596970999965],
          [120.318764292000068, 23.915800042999976],
          [120.319187350000107, 23.915440755],
          [120.319553165, 23.915261793999989],
          [120.319442393000017, 23.914977558],
          [120.31869432800012, 23.913091128999987],
          [120.318386755999981, 23.91285763199998],
          [120.31783391799999, 23.91120425599999],
          [120.317687128000102, 23.910185794000011],
          [120.317624007000063, 23.909639855999988],
          [120.317678561000093, 23.907998647999971],
          [120.317781463000088, 23.907241218],
          [120.317883889000086, 23.90659494899999],
          [120.318051023000066, 23.906171232],
          [120.318139464000069, 23.906090805999987],
          [120.318579956, 23.905951310000027],
          [120.319240649000108, 23.905792540999958],
          [120.319527195000092, 23.905662456999988],
          [120.320001419000036, 23.90539169700002],
          [120.320277482000023, 23.905180689000012],
          [120.320552746000075, 23.90510108699997],
          [120.320843828000079, 23.90507248399999],
          [120.321360154000089, 23.905155582],
          [120.322216099, 23.905492842999973],
          [120.322688110000058, 23.90566671399999],
          [120.323051075000066, 23.905648063999973],
          [120.323711598000045, 23.905499426999988],
          [120.323811098000064, 23.905388703],
          [120.321527245000084, 23.899418318999984],
          [120.321004030000026, 23.897980092],
          [120.32075758200007, 23.897817761999967],
          [120.320464423000075, 23.897509409999987],
          [120.319802200000012, 23.89636860400002],
          [120.319084638000035, 23.894523202],
          [120.318932044999983, 23.893646559999972],
          [120.318877553000064, 23.893515423999979],
          [120.318468106000068, 23.89363837599999],
          [120.317785704000016, 23.893844515],
          [120.316844152000016, 23.894121480999985],
          [120.316549400000085, 23.894208793999987],
          [120.315770331000053, 23.894440968],
          [120.315482032000091, 23.894523881999969],
          [120.315402061000086, 23.894548998999976],
          [120.315302127, 23.89428707599999],
          [120.315106728000046, 23.893791726],
          [120.315073323000092, 23.893705050999973],
          [120.314433818, 23.893907527999989],
          [120.313654724, 23.894148828],
          [120.313235910000017, 23.894279915000023],
          [120.31278860799999, 23.894412886999973],
          [120.312237683000035, 23.894589159],
          [120.312179696000058, 23.894606641999964],
          [120.312064992000032, 23.894179316000017],
          [120.311954739000029, 23.893737481999988],
          [120.311772833000049, 23.893166777000026],
          [120.311544867000038, 23.892473284999976],
          [120.311418225, 23.89208887500001],
          [120.311199871000085, 23.890842961000015],
          [120.311192569000013, 23.890818350000018],
          [120.311165826000092, 23.890815495000016],
          [120.311165187000014, 23.890655718999966],
          [120.311165519000028, 23.890590457],
          [120.311174488999981, 23.890580944000011],
          [120.311156847000021, 23.890543997999984],
          [120.311001404000066, 23.890143188],
          [120.310889536000104, 23.889858915999969],
          [120.310665159, 23.88956295199999],
          [120.310674041000084, 23.889548184000017],
          [120.310544188000094, 23.889087416999981],
          [120.310440264999983, 23.888721274000019],
          [120.310422469000045, 23.888713004999982],
          [120.310251482999988, 23.889000370999987],
          [120.310043245000102, 23.889092127000012],
          [120.309374626000022, 23.88937685],
          [120.309396409000087, 23.889473903999985],
          [120.308502127000011, 23.889760043],
          [120.308136342000012, 23.889878559999982],
          [120.307342637, 23.890140611999975],
          [120.307025583000041, 23.889299715999964],
          [120.306106511000038, 23.88956996400001],
          [120.306429638000026, 23.890495149999968],
          [120.306472072, 23.890611529999983],
          [120.306471733000052, 23.890620837000021],
          [120.306110801000031, 23.890683479999986],
          [120.30619494400004, 23.891052191000014],
          [120.306413069000087, 23.891527815],
          [120.30659959400009, 23.891950729],
          [120.306616966000107, 23.89222520600001],
          [120.30658131000007, 23.89235112],
          [120.306556346000065, 23.892446429999982],
          [120.306582292000016, 23.892627005],
          [120.306594374000042, 23.892884158],
          [120.306620650000028, 23.89300293],
          [120.306582355000018, 23.893118936999972],
          [120.30661439800005, 23.893166060999977],
          [120.306071038000027, 23.893121579],
          [120.306068504, 23.893091898],
          [120.305755755000078, 23.89320172799999],
          [120.304829535000067, 23.893532594],
          [120.303408055000091, 23.89403169299997],
          [120.303096663000034, 23.894190119000022],
          [120.302504675000037, 23.89445612799999],
          [120.302382914000063, 23.894518952999967],
          [120.302154607000048, 23.894610547999978],
          [120.301137586000081, 23.89488477299998],
          [120.299734697000076, 23.895295019999971],
          [120.299561037000061, 23.89474667],
          [120.299356447, 23.894816717000015],
          [120.299380926000026, 23.894882741999986],
          [120.297853198000098, 23.895319238],
          [120.297422827000091, 23.895294465999982],
          [120.29742231900002, 23.895388249999986],
          [120.296919444000096, 23.895502555999979],
          [120.296449829000053, 23.895715187999979],
          [120.295980199000027, 23.895930012],
          [120.295510556000067, 23.896147019],
          [120.2950409, 23.896366229],
          [120.294571230000088, 23.896587629999985],
          [120.294101546000093, 23.896811215],
          [120.293631849999983, 23.897036994],
          [120.293162140000049, 23.897264972999984],
          [120.292692417000012, 23.897495136000028],
          [120.292222679, 23.89772749099999],
          [120.291752927000047, 23.89796204],
          [120.291283163, 23.898198780000019],
          [120.290813386000053, 23.898437723],
          [120.290343593000102, 23.898678839999988],
          [120.289873786000015, 23.898922158],
          [120.28940396599999, 23.899167668999986],
          [120.288934132999955, 23.899415372],
          [120.288464284000057, 23.89966526900001],
          [120.287994423000086, 23.899917349000017],
          [120.287524548000079, 23.900171628999967],
          [120.287054658000102, 23.900428094],
          [120.286584756000039, 23.90068676100001],
          [120.286114838, 23.90094762],
          [120.285644909000112, 23.901210661999961],
          [120.285174963000017, 23.90147589699999],
          [120.284705005000092, 23.901743333999978],
          [120.284235033000058, 23.902012952999982],
          [120.283765044999981, 23.902284765999958],
          [120.283295044000042, 23.902558780999971],
          [120.282825031000016, 23.902834969000011],
          [120.282355001000013, 23.903113367999985],
          [120.281884956, 23.903393950999988],
          [120.281414901000062, 23.903676726999986],
          [120.280944828000102, 23.903961694000014],
          [120.28047474200001, 23.904248854999977],
          [120.280004642000094, 23.904538208],
          [120.279534525000017, 23.904829743999972],
          [120.279064396000081, 23.905123483],
          [120.278594253000051, 23.905419413999976],
          [120.278124095000052, 23.905717535999976],
          [120.277653922000013, 23.906017843],
          [120.277183736000097, 23.906320352],
          [120.276713534999985, 23.906625043],
          [120.276243321000024, 23.90693193700001],
          [120.275773091000019, 23.90724100399999],
          [120.275302846000031, 23.907552283],
          [120.274832588000109, 23.907865744999963],
          [120.274362317000055, 23.908181398999986],
          [120.273892028000091, 23.908499246],
          [120.273421726000038, 23.908819284999982],
          [120.272951410000019, 23.909141518],
          [120.27248107900003, 23.909465941999976],
          [120.272010733, 23.909792558999957],
          [120.271540371, 23.910121359999984],
          [120.271069996000065, 23.910452351999979],
          [120.270599605, 23.910785556999983],
          [120.270129199000053, 23.911120934999968],
          [120.269658777999979, 23.911458513999982],
          [120.269188343, 23.911798286],
          [120.268717894000019, 23.912140241000014],
          [120.268247429000098, 23.912484398999982],
          [120.267776948, 23.912830739999986],
          [120.267306454, 23.913179281999966],
          [120.266835945, 23.913530008],
          [120.266365421000017, 23.913882925999964],
          [120.265894883000087, 23.914238037],
          [120.26542432699999, 23.91459534900001],
          [120.264953759000022, 23.914954835999971],
          [120.26448317400002, 23.915316524999962],
          [120.264012576000013, 23.915680404999964],
          [120.263541962000062, 23.916046468999955],
          [120.263071331000077, 23.91641474399999],
          [120.262600688000035, 23.916785193],
          [120.262130029000062, 23.917157844000013],
          [120.261659354, 23.917532679000018],
          [120.261188663000098, 23.917909714],
          [120.26071795900009, 23.91828893299996],
          [120.260638651000022, 23.918353191999969],
          [120.261045015, 23.919730993000019],
          [120.26182048400004, 23.920294877999972],
          [120.262570892000099, 23.920835806],
          [120.263746467, 23.921825413],
          [120.265171922000036, 23.92374641799999],
          [120.265984514, 23.925632420999968],
          [120.267184709000048, 23.928185429999971],
          [120.26848523000001, 23.92962340799998],
          [120.269135443000053, 23.930589508000018],
          [120.270423776000044, 23.931061886],
          [120.272040993, 23.931509547],
          [120.309822347999983, 23.918494394999964],
          [120.310690212000054, 23.918588976000017],
          [120.311262538000037, 23.91859154099999],
          [120.311896054000059, 23.918231685],
          [120.312471161000047, 23.91770833899999],
          [120.312906002000091, 23.917583355000016],
          [120.313359606000063, 23.917639772],
          [120.313981789000081, 23.917713443000011],
          [120.314290590000027, 23.91771482],
          [120.314712874000065, 23.91748456899999],
          [120.315280590000043, 23.917186327999989],
          [120.315377866000034, 23.917116345],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '王功村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-015',
      VILLAGE_ID: '015',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.357137438, 23.972500484999987],
          [120.357147816000065, 23.97079967],
          [120.357317350999978, 23.969310984999986],
          [120.357555489000063, 23.968851621999971],
          [120.358207250000063, 23.96821797099998],
          [120.358650820000094, 23.96794902700001],
          [120.359481382000013, 23.967703868999973],
          [120.360751435, 23.967235268999985],
          [120.361931433, 23.967091238999988],
          [120.361933899000064, 23.96659026799999],
          [120.360585509000074, 23.961292112],
          [120.360431140000074, 23.960541255],
          [120.360497657, 23.96040843799999],
          [120.361025329000086, 23.960253329],
          [120.360963742000081, 23.960042720999976],
          [120.359254140000075, 23.95540826],
          [120.359251156000028, 23.953842213000019],
          [120.359245262000059, 23.951401253],
          [120.357817356000055, 23.9513901],
          [120.357181939000029, 23.951602135000023],
          [120.356478993, 23.951967238],
          [120.355843571000037, 23.952179266000027],
          [120.355007908000033, 23.952375117000013],
          [120.354455268000024, 23.952725517000019],
          [120.353532993000016, 23.953549737999971],
          [120.352670744000065, 23.954301773999966],
          [120.352217401000061, 23.95482126400001],
          [120.350803994000088, 23.95703892],
          [120.35031671, 23.957665602],
          [120.349659950000046, 23.958662133999979],
          [120.349315312000058, 23.959036059000013],
          [120.348879203000038, 23.959252176999971],
          [120.34864094, 23.959444920999974],
          [120.347311404000024, 23.96026659599999],
          [120.345794016999989, 23.96091208],
          [120.344523476000077, 23.961267517999975],
          [120.342081224000026, 23.962045099],
          [120.342041241000061, 23.961958964999987],
          [120.341878184000066, 23.962020864999975],
          [120.341819141000073, 23.962048648999978],
          [120.341775727000027, 23.962074697999967],
          [120.341740995999984, 23.962111164999989],
          [120.341701056000019, 23.962166734999968],
          [120.341643749000013, 23.962227513999984],
          [120.341525664000045, 23.962303922999961],
          [120.341364164000069, 23.96241158899999],
          [120.341195719000098, 23.96250536299997],
          [120.340886612000077, 23.962659915999986],
          [120.340450738000072, 23.962804049999963],
          [120.340325932999988, 23.962850526999976],
          [120.340239321000027, 23.962877176999985],
          [120.340103035000084, 23.96290073499999],
          [120.340144483, 23.963026719000016],
          [120.340168845000065, 23.963121462999986],
          [120.340174259000037, 23.963262224999987],
          [120.340198622, 23.963478783],
          [120.340231106000033, 23.963692633999962],
          [120.340247348000034, 23.963819860999962],
          [120.340236715000046, 23.964334628999989],
          [120.340233716000057, 23.964487614999971],
          [120.340233716000057, 23.964574607000014],
          [120.340257713000014, 23.9646526],
          [120.340311709000034, 23.964748590999967],
          [120.341037642000046, 23.965720501999986],
          [120.341842204000031, 23.966627897000016],
          [120.340925039999988, 23.96700665099999],
          [120.339737266000043, 23.967563874999975],
          [120.338599105000057, 23.967791664],
          [120.338022113000079, 23.967789175999989],
          [120.336680973000071, 23.967790546999982],
          [120.334389863000069, 23.967728011],
          [120.332743538000031, 23.967688681],
          [120.330248860000083, 23.96758422299999],
          [120.327283715, 23.967314197999972],
          [120.326169255000096, 23.967207097000021],
          [120.323581567, 23.967119023999977],
          [120.307702038000016, 23.973145429999978],
          [120.308376834, 23.975259970999989],
          [120.308426497000013, 23.976570009999968],
          [120.308362551000059, 23.981913168999988],
          [120.308287048, 23.98345281500001],
          [120.308711572000092, 23.986905190999984],
          [120.330622509000023, 23.979625995999971],
          [120.33459339500007, 23.978335991999963],
          [120.33602991799998, 23.977847153000013],
          [120.338548572000036, 23.977034117],
          [120.340280923000023, 23.976456593],
          [120.342620641000025, 23.975670254999986],
          [120.344443521000017, 23.975124591999965],
          [120.346723517000086, 23.974511614999976],
          [120.348142377000045, 23.974108764999958],
          [120.348670707, 23.974015515],
          [120.348839224, 23.973906038999967],
          [120.349040233000096, 23.97369386099999],
          [120.349112492000017, 23.973639073999987],
          [120.349798301000064, 23.97334002199999],
          [120.350489926, 23.973131524999971],
          [120.351054794000092, 23.972954205],
          [120.353478297000052, 23.972554503],
          [120.355526687000079, 23.972172149999988],
          [120.356132665, 23.972129580999979],
          [120.356557723000037, 23.972251663999984],
          [120.357137438, 23.972500484999987],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '博愛村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-016',
      VILLAGE_ID: '016',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.340236715000046, 23.964334628999989],
          [120.340085934000058, 23.96433974],
          [120.339676779000015, 23.963897368999969],
          [120.339559014000088, 23.963746388999972],
          [120.339193643000044, 23.963196821999968],
          [120.339019845000053, 23.96327780099999],
          [120.338735986000046, 23.963420295999956],
          [120.338794794, 23.96354356499999],
          [120.338274574000039, 23.963880576999976],
          [120.338429942000062, 23.96409256299999],
          [120.338558846000055, 23.964361793000013],
          [120.338702965000039, 23.964586903999962],
          [120.338794677, 23.964808442999956],
          [120.338848275000032, 23.964893008999951],
          [120.33896380899999, 23.965025216999983],
          [120.338992607000037, 23.965076432999957],
          [120.338728840000044, 23.965229755999975],
          [120.33855862599999, 23.965047846999973],
          [120.338298756000086, 23.964723010999961],
          [120.338210401000069, 23.964595674999973],
          [120.33810515399999, 23.96440597],
          [120.338011601000048, 23.96422796],
          [120.336866328000042, 23.961743398999985],
          [120.336811600000047, 23.961553041999977],
          [120.336712595000094, 23.961371322999959],
          [120.336588791000011, 23.961464730999964],
          [120.335765846000058, 23.96217976699999],
          [120.333166804000015, 23.96386473499999],
          [120.328436450000027, 23.966567718],
          [120.327283715, 23.967314197999972],
          [120.330248860000083, 23.96758422299999],
          [120.332743538000031, 23.967688681],
          [120.334389863000069, 23.967728011],
          [120.336680973000071, 23.967790546999982],
          [120.338022113000079, 23.967789175999989],
          [120.338599105000057, 23.967791664],
          [120.339737266000043, 23.967563874999975],
          [120.340925039999988, 23.96700665099999],
          [120.341842204000031, 23.966627897000016],
          [120.341037642000046, 23.965720501999986],
          [120.340311709000034, 23.964748590999967],
          [120.340257713000014, 23.9646526],
          [120.340233716000057, 23.964574607000014],
          [120.340233716000057, 23.964487614999971],
          [120.340236715000046, 23.964334628999989],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '和平村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-017',
      VILLAGE_ID: '017',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.327283715, 23.967314197999972],
          [120.328436450000027, 23.966567718],
          [120.333166804000015, 23.96386473499999],
          [120.335765846000058, 23.96217976699999],
          [120.336588791000011, 23.961464730999964],
          [120.336712595000094, 23.961371322999959],
          [120.336811600000047, 23.961553041999977],
          [120.336866328000042, 23.961743398999985],
          [120.338011601000048, 23.96422796],
          [120.33810515399999, 23.96440597],
          [120.338210401000069, 23.964595674999973],
          [120.338298756000086, 23.964723010999961],
          [120.33855862599999, 23.965047846999973],
          [120.338728840000044, 23.965229755999975],
          [120.338992607000037, 23.965076432999957],
          [120.33896380899999, 23.965025216999983],
          [120.338848275000032, 23.964893008999951],
          [120.338794677, 23.964808442999956],
          [120.338702965000039, 23.964586903999962],
          [120.338558846000055, 23.964361793000013],
          [120.338429942000062, 23.96409256299999],
          [120.338274574000039, 23.963880576999976],
          [120.338794794, 23.96354356499999],
          [120.338735986000046, 23.963420295999956],
          [120.339019845000053, 23.96327780099999],
          [120.339193643000044, 23.963196821999968],
          [120.338990208999988, 23.962893258999987],
          [120.338897303000081, 23.962938679999965],
          [120.338547356000035, 23.963055328999967],
          [120.337685183000076, 23.96130295],
          [120.333930783000028, 23.95343546299999],
          [120.333833486, 23.953437847000014],
          [120.331734150000074, 23.95397898599996],
          [120.331518685000091, 23.954062706999967],
          [120.331464597000036, 23.954125962000017],
          [120.331448549000015, 23.95425993199999],
          [120.331860339000045, 23.954826093999973],
          [120.332050581000104, 23.955165551999965],
          [120.33205007299999, 23.95526431],
          [120.331926660000036, 23.955369592999986],
          [120.331371683000043, 23.955762236999984],
          [120.32976885100004, 23.956633172999982],
          [120.327927957000043, 23.957641319999979],
          [120.323763371000013, 23.959923127],
          [120.320828779000067, 23.961573974000011],
          [120.304715992000027, 23.970544467000014],
          [120.305100681, 23.970833340999974],
          [120.306914066000104, 23.97222522399997],
          [120.307701924000071, 23.973145071000015],
          [120.307702038000016, 23.973145429999978],
          [120.323581567, 23.967119023999977],
          [120.326169255000096, 23.967207097000021],
          [120.327283715, 23.967314197999972],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '民生村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-018',
      VILLAGE_ID: '018',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.340236715000046, 23.964334628999989],
          [120.340247348000034, 23.963819860999962],
          [120.340231106000033, 23.963692633999962],
          [120.340198622, 23.963478783],
          [120.340174259000037, 23.963262224999987],
          [120.340168845000065, 23.963121462999986],
          [120.340144483, 23.963026719000016],
          [120.340103035000084, 23.96290073499999],
          [120.339912678, 23.96246945699998],
          [120.339784782000024, 23.962148230000011],
          [120.33962119400006, 23.961580134000023],
          [120.339285095000022, 23.96179131099999],
          [120.338847868999963, 23.961583108],
          [120.338743768000072, 23.961550389999989],
          [120.338627768999984, 23.96152659599999],
          [120.338493924000048, 23.961481981],
          [120.33859505100007, 23.961413570999962],
          [120.338809203000068, 23.961181574],
          [120.338946022000044, 23.961056652],
          [120.339175045000047, 23.960896039000016],
          [120.33931483800005, 23.96081870599998],
          [120.339421914000013, 23.960780040000014],
          [120.339457606, 23.960762193999976],
          [120.339478426000028, 23.960723528],
          [120.339481400000068, 23.960675938999987],
          [120.339478426000028, 23.96060752899999],
          [120.339365402, 23.960057279],
          [120.339299967000088, 23.959646822000014],
          [120.339294018000032, 23.959605181000011],
          [120.339270223000099, 23.959560565999968],
          [120.339189916000024, 23.959462412999969],
          [120.339139353000064, 23.9590817],
          [120.339112584000077, 23.95900139299998],
          [120.339180993000014, 23.958769394999969],
          [120.339186942000069, 23.958715857999987],
          [120.339175045000019, 23.95866529400001],
          [120.339136379000024, 23.958593909999969],
          [120.33910663499999, 23.958528474999962],
          [120.338898433000068, 23.957695664],
          [120.338862741000071, 23.957511254999957],
          [120.338812177000037, 23.957344692999964],
          [120.338714024000083, 23.957100797999971],
          [120.33820244, 23.955690967999985],
          [120.338137005, 23.955476815999958],
          [120.338107262000108, 23.955334048999969],
          [120.338101313000024, 23.955155589],
          [120.338107262000108, 23.955027693000012],
          [120.338125108000085, 23.954917642999977],
          [120.338214337000082, 23.954569647000021],
          [120.338151877000072, 23.95440308400001],
          [120.338065621000041, 23.954203805],
          [120.33776818900003, 23.953326377999971],
          [120.337598652000011, 23.952788025],
          [120.337027581000029, 23.951285991],
          [120.333263978000105, 23.952041915999978],
          [120.333930783000028, 23.95343546299999],
          [120.337685183000076, 23.96130295],
          [120.338547356000035, 23.963055328999967],
          [120.338897303000081, 23.962938679999965],
          [120.338990208999988, 23.962893258999987],
          [120.339193643000044, 23.963196821999968],
          [120.339559014000088, 23.963746388999972],
          [120.339676779000015, 23.963897368999969],
          [120.340085934000058, 23.96433974],
          [120.340236715000046, 23.964334628999989],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '興仁村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-019',
      VILLAGE_ID: '019',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.359245262000059, 23.951401253],
          [120.359497383000061, 23.951403220000024],
          [120.359390499000014, 23.95034341099999],
          [120.359222918, 23.949715554],
          [120.358960266000039, 23.949139556000016],
          [120.358431362000047, 23.948719241999957],
          [120.356879192000022, 23.948137847999973],
          [120.356236166000031, 23.947786736],
          [120.355859756000058, 23.94721025599998],
          [120.355340207000026, 23.944908488],
          [120.355097509000061, 23.944140936999972],
          [120.354538538000028, 23.942343220999984],
          [120.354274379, 23.942373075000027],
          [120.353184709000047, 23.942231482],
          [120.35039007500005, 23.94165170699999],
          [120.347611405000066, 23.940972568],
          [120.345643480000035, 23.939993919],
          [120.345332067000072, 23.939884257],
          [120.344986038, 23.942252885000013],
          [120.34476945300004, 23.944062447],
          [120.344661797000029, 23.94484335299999],
          [120.344409585000108, 23.94549024199999],
          [120.343985877, 23.947573223],
          [120.343424851999984, 23.94903073],
          [120.343072795, 23.949890694000025],
          [120.342974062000053, 23.950202639999976],
          [120.342927099999983, 23.950459159999962],
          [120.337027581000029, 23.951285991],
          [120.337598652000011, 23.952788025],
          [120.33776818900003, 23.953326377999971],
          [120.338065621000041, 23.954203805],
          [120.338151877000072, 23.95440308400001],
          [120.338214337000082, 23.954569647000021],
          [120.338125108000085, 23.954917642999977],
          [120.338107262000108, 23.955027693000012],
          [120.338101313000024, 23.955155589],
          [120.338107262000108, 23.955334048999969],
          [120.338137005, 23.955476815999958],
          [120.33820244, 23.955690967999985],
          [120.338714024000083, 23.957100797999971],
          [120.338812177000037, 23.957344692999964],
          [120.338862741000071, 23.957511254999957],
          [120.338898433000068, 23.957695664],
          [120.33910663499999, 23.958528474999962],
          [120.339136379000024, 23.958593909999969],
          [120.339175045000019, 23.95866529400001],
          [120.339186942000069, 23.958715857999987],
          [120.339180993000014, 23.958769394999969],
          [120.339112584000077, 23.95900139299998],
          [120.339139353000064, 23.9590817],
          [120.339189916000024, 23.959462412999969],
          [120.339270223000099, 23.959560565999968],
          [120.339294018000032, 23.959605181000011],
          [120.339299967000088, 23.959646822000014],
          [120.339365402, 23.960057279],
          [120.339478426000028, 23.96060752899999],
          [120.339481400000068, 23.960675938999987],
          [120.339478426000028, 23.960723528],
          [120.339457606, 23.960762193999976],
          [120.339421914000013, 23.960780040000014],
          [120.33931483800005, 23.96081870599998],
          [120.339175045000047, 23.960896039000016],
          [120.338946022000044, 23.961056652],
          [120.338809203000068, 23.961181574],
          [120.33859505100007, 23.961413570999962],
          [120.338493924000048, 23.961481981],
          [120.338627768999984, 23.96152659599999],
          [120.338743768000072, 23.961550389999989],
          [120.338847868999963, 23.961583108],
          [120.339285095000022, 23.96179131099999],
          [120.33962119400006, 23.961580134000023],
          [120.339784782000024, 23.962148230000011],
          [120.339912678, 23.96246945699998],
          [120.340103035000084, 23.96290073499999],
          [120.340239321000027, 23.962877176999985],
          [120.340325932999988, 23.962850526999976],
          [120.340450738000072, 23.962804049999963],
          [120.340886612000077, 23.962659915999986],
          [120.341195719000098, 23.96250536299997],
          [120.341364164000069, 23.96241158899999],
          [120.341525664000045, 23.962303922999961],
          [120.341643749000013, 23.962227513999984],
          [120.341701056000019, 23.962166734999968],
          [120.341740995999984, 23.962111164999989],
          [120.341775727000027, 23.962074697999967],
          [120.341819141000073, 23.962048648999978],
          [120.341878184000066, 23.962020864999975],
          [120.342041241000061, 23.961958964999987],
          [120.342081224000026, 23.962045099],
          [120.344523476000077, 23.961267517999975],
          [120.345794016999989, 23.96091208],
          [120.347311404000024, 23.96026659599999],
          [120.34864094, 23.959444920999974],
          [120.348879203000038, 23.959252176999971],
          [120.349315312000058, 23.959036059000013],
          [120.349659950000046, 23.958662133999979],
          [120.35031671, 23.957665602],
          [120.350803994000088, 23.95703892],
          [120.352217401000061, 23.95482126400001],
          [120.352670744000065, 23.954301773999966],
          [120.353532993000016, 23.953549737999971],
          [120.354455268000024, 23.952725517000019],
          [120.355007908000033, 23.952375117000013],
          [120.355843571000037, 23.952179266000027],
          [120.356478993, 23.951967238],
          [120.357181939000029, 23.951602135000023],
          [120.357817356000055, 23.9513901],
          [120.359245262000059, 23.951401253],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '新寶村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-020',
      VILLAGE_ID: '020',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.36811078900007, 23.988222683999975],
          [120.367988813, 23.987927485999968],
          [120.367997104000096, 23.987614485999966],
          [120.369026272000056, 23.986263683999983],
          [120.368790694000054, 23.986253307],
          [120.36785362, 23.986183584],
          [120.367273053000076, 23.986089545],
          [120.366351637000079, 23.985876329],
          [120.365399689000014, 23.985548753999957],
          [120.36377738200008, 23.984542575],
          [120.363378537, 23.984213682],
          [120.363203829000057, 23.983766141999965],
          [120.36305752400007, 23.98353535],
          [120.362749135000044, 23.983290350999969],
          [120.362338001000012, 23.982950142999968],
          [120.361723821000055, 23.98193209799999],
          [120.361125913, 23.980602689999987],
          [120.360907182, 23.980114339999975],
          [120.36068537300001, 23.979834872000012],
          [120.360044468000055, 23.97826156],
          [120.359168618999988, 23.976124146999982],
          [120.358775473, 23.975134092],
          [120.35858658700009, 23.974578161999982],
          [120.357869001000026, 23.973613828999962],
          [120.357137438, 23.972500484999987],
          [120.356557723000037, 23.972251663999984],
          [120.356132665, 23.972129580999979],
          [120.355526687000079, 23.972172149999988],
          [120.353478297000052, 23.972554503],
          [120.351054794000092, 23.972954205],
          [120.350489926, 23.973131524999971],
          [120.349798301000064, 23.97334002199999],
          [120.349112492000017, 23.973639073999987],
          [120.349040233000096, 23.97369386099999],
          [120.348839224, 23.973906038999967],
          [120.348670707, 23.974015515],
          [120.348142377000045, 23.974108764999958],
          [120.346723517000086, 23.974511614999976],
          [120.344443521000017, 23.975124591999965],
          [120.342620641000025, 23.975670254999986],
          [120.340280923000023, 23.976456593],
          [120.338548572000036, 23.977034117],
          [120.33602991799998, 23.977847153000013],
          [120.33459339500007, 23.978335991999963],
          [120.330622509000023, 23.979625995999971],
          [120.308711572000092, 23.986905190999984],
          [120.308736395000068, 23.987107041999973],
          [120.308999047000057, 23.987302650999975],
          [120.310012202000038, 23.987751490999962],
          [120.310925187000066, 23.988349677000016],
          [120.311862969, 23.989775120999951],
          [120.31278813600008, 23.99162573099999],
          [120.313925843000106, 23.993912986999963],
          [120.315251123000053, 23.996763373],
          [120.316451260999955, 23.999234470000015],
          [120.316451517, 23.99923482899996],
          [120.349357515000065, 23.99095825],
          [120.351078295000093, 23.992219199000012],
          [120.351470283000026, 23.992420297],
          [120.352390088000092, 23.992547656999964],
          [120.353228065000067, 23.992494206999986],
          [120.35354918500002, 23.99239108599998],
          [120.353988133000016, 23.99211698],
          [120.35427847299999, 23.991966240999989],
          [120.355003427000028, 23.991760352000021],
          [120.357025886000073, 23.991141002],
          [120.357720314000062, 23.991052870000019],
          [120.35816645400007, 23.991054737999981],
          [120.358844205000082, 23.990996875],
          [120.360465296000029, 23.990639456999965],
          [120.361573720000024, 23.990370929999969],
          [120.362666345000079, 23.989950588999971],
          [120.364645293000081, 23.989339678],
          [120.367663887000049, 23.988354511],
          [120.36811078900007, 23.988222683999975],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '草湖村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-021',
      VILLAGE_ID: '021',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.383141242000079, 23.948515434999965],
          [120.383040362000102, 23.948504338],
          [120.383036855, 23.948256489],
          [120.383050371000095, 23.947727589],
          [120.383050919000098, 23.947612322999966],
          [120.382997535000072, 23.947617869999963],
          [120.382812288000082, 23.947631544999972],
          [120.382649066, 23.947633768999971],
          [120.382403149000083, 23.947686072],
          [120.382092167, 23.947739584000018],
          [120.38180631900002, 23.947787417],
          [120.381793284000082, 23.947888222],
          [120.381733471000075, 23.947925444],
          [120.381623439999984, 23.947962472000011],
          [120.381544811000026, 23.947996738000015],
          [120.38150685700009, 23.948057098999964],
          [120.381497112000034, 23.948126214999984],
          [120.381506143000024, 23.948206936999984],
          [120.381536435000044, 23.94825672000001],
          [120.381558650000102, 23.948326496999982],
          [120.380503880000106, 23.948470218],
          [120.380462331000103, 23.948256877999988],
          [120.380450754000094, 23.948084707000014],
          [120.380401224000025, 23.947751217999986],
          [120.380396651000055, 23.947638531999967],
          [120.380437818000019, 23.947582364000016],
          [120.380632312000088, 23.947536205999981],
          [120.381415056000037, 23.947421989],
          [120.381788570000012, 23.947357758999988],
          [120.381875680999954, 23.94731587099999],
          [120.381901758000012, 23.947208003],
          [120.381887585000072, 23.946963848999971],
          [120.381777377000049, 23.946489295999967],
          [120.381747761000042, 23.946306396999983],
          [120.38171231, 23.946235842999986],
          [120.381697399, 23.946146591999977],
          [120.381703272000095, 23.945987014],
          [120.381751076, 23.94561167],
          [120.381793787000092, 23.945231609],
          [120.381846610000011, 23.944875065999984],
          [120.381894031, 23.944579519999984],
          [120.381910018000085, 23.944443449999984],
          [120.381915649999968, 23.944331680999976],
          [120.38189085000009, 23.944171979000025],
          [120.381897507000062, 23.943848097999982],
          [120.381868155, 23.94357103399998],
          [120.381818332000094, 23.943298564000017],
          [120.381728508000023, 23.94283817],
          [120.38165835000008, 23.942542150999987],
          [120.38161814700004, 23.942396473000013],
          [120.381592959000031, 23.942307722],
          [120.381573028000048, 23.942199678],
          [120.381569103000061, 23.941950870000014],
          [120.381592553000019, 23.94132193799998],
          [120.381572934, 23.941148181],
          [120.381589169000108, 23.94096046399999],
          [120.38164266200009, 23.940463102],
          [120.381648737000077, 23.940261276999973],
          [120.381655882000018, 23.939853686999978],
          [120.381652405000054, 23.939510983999956],
          [120.381654129000012, 23.939149539000013],
          [120.381650094000065, 23.938924206000014],
          [120.381681840000056, 23.938699008],
          [120.381749663000036, 23.93841292599999],
          [120.382004377000044, 23.937565566999961],
          [120.382155175000079, 23.937031034000015],
          [120.382248890000028, 23.936674644999965],
          [120.382343001000081, 23.936366239999966],
          [120.382379768000078, 23.936159841999977],
          [120.382443641, 23.935629645999981],
          [120.382501794000063, 23.935226178999969],
          [120.382549276000077, 23.934916547999983],
          [120.382560306000087, 23.934747599999959],
          [120.382555717000059, 23.934644945999977],
          [120.382525357000063, 23.934579107999966],
          [120.382332384000037, 23.934310757999956],
          [120.38229687, 23.93425429099999],
          [120.382281936000012, 23.934169734999987],
          [120.38229285400007, 23.934024253],
          [120.382298905000056, 23.933827123],
          [120.382345650000033, 23.933672402999981],
          [120.382458983000106, 23.93348979],
          [120.382598051000045, 23.933269708999976],
          [120.382711383000029, 23.933087085999983],
          [120.38275297000007, 23.932941727999985],
          [120.382764508000022, 23.932713034999988],
          [120.382780649000082, 23.932544107999981],
          [120.382776231000094, 23.932398563999975],
          [120.38279728100008, 23.93227190499999],
          [120.382874494000021, 23.932159547],
          [120.382997667000026, 23.932056772999985],
          [120.383064567000019, 23.931963155999973],
          [120.383054634999979, 23.931902085999969],
          [120.382963183, 23.931784365999974],
          [120.382825880000027, 23.931633603000023],
          [120.38276996400009, 23.931567663],
          [120.382693579000033, 23.931506327],
          [120.382622732000087, 23.931355831],
          [120.3825674200001, 23.931163147999971],
          [120.382431996000051, 23.930619563999979],
          [120.382251267000015, 23.92992879099999],
          [120.382166113000054, 23.929562301],
          [120.382141507000014, 23.929361507999985],
          [120.382015976000019, 23.928886883],
          [120.38188056, 23.928341808000017],
          [120.381820519, 23.928069305999973],
          [120.381795924000031, 23.927867357],
          [120.381751217000101, 23.927594907],
          [120.381676092, 23.927159319999969],
          [120.38161161000005, 23.92674597],
          [120.381586590000097, 23.926633201000016],
          [120.3815495, 23.926567228999989],
          [120.381535552000045, 23.926420591],
          [120.381502378000036, 23.926204051999978],
          [120.381470420000028, 23.925975138],
          [120.381434671000079, 23.925766732999985],
          [120.381424827000032, 23.925645004999964],
          [120.38133135300005, 23.92558646299999],
          [120.381278402000035, 23.925531558999957],
          [120.381140627000036, 23.925463528999988],
          [120.38088774399999, 23.925356631999975],
          [120.380468396000083, 23.925200757],
          [120.380164809, 23.92509948],
          [120.380013028000022, 23.925046515999977],
          [120.379569287000095, 23.924943028000012],
          [120.379445259000036, 23.924914607999987],
          [120.379405934, 23.92492492399996],
          [120.379304630000064, 23.924914041],
          [120.379187332000015, 23.924881639],
          [120.379042985000069, 23.924863602],
          [120.378968242000042, 23.924862135999987],
          [120.37882644900003, 23.924839468],
          [120.37870233, 23.924830821999961],
          [120.378475665000011, 23.924805471999985],
          [120.378298729000107, 23.924780287000022],
          [120.378071970000036, 23.924774728999964],
          [120.377760452000061, 23.924743218999971],
          [120.377586941000018, 23.92472973100001],
          [120.377516083000046, 23.924710826000016],
          [120.377436445000058, 23.924708119999966],
          [120.377326305, 23.924690219999977],
          [120.377179442000056, 23.924668676999978],
          [120.377021231000057, 23.924635458],
          [120.376917432000027, 23.92461643599999],
          [120.376829639000093, 23.924601290999973],
          [120.376806442000088, 23.924538090999967],
          [120.376675099000053, 23.92421365],
          [120.376599556000087, 23.923978636],
          [120.376523833000078, 23.923781173999977],
          [120.376468420000023, 23.923611956999974],
          [120.37635158, 23.923461261999979],
          [120.376229494000071, 23.92333872599999],
          [120.376142040000104, 23.92325707199999],
          [120.375944644000015, 23.923160992],
          [120.375738909999981, 23.923057164999982],
          [120.375649477000039, 23.923012029999988],
          [120.375499036000065, 23.922992349000015],
          [120.375244833999972, 23.923004930999973],
          [120.375019162000058, 23.923088068],
          [120.374837536000086, 23.92316168599999],
          [120.374659592000071, 23.923201367999972],
          [120.37453101199999, 23.923223472],
          [120.374347981000028, 23.923222726999988],
          [120.374249487000043, 23.923194859000013],
          [120.373888546000089, 23.923115728000024],
          [120.373555569000018, 23.92305108499999],
          [120.37324840699999, 23.922979231999971],
          [120.372980060000032, 23.922829877],
          [120.37261902, 23.922771924999974],
          [120.372296485000092, 23.922700007999985],
          [120.37202790000002, 23.922600075999966],
          [120.371682236000083, 23.92254218599998],
          [120.371574611000028, 23.922541744999982],
          [120.37142021, 23.922675261999959],
          [120.370999931000028, 23.923039925999984],
          [120.370915264000033, 23.923060752],
          [120.370291356000038, 23.922940567999984],
          [120.370011876000035, 23.92493638],
          [120.369902536000041, 23.926368729999961],
          [120.369956965000029, 23.929184110999973],
          [120.370118407000064, 23.93136624899999],
          [120.370251174000018, 23.93207058],
          [120.370504608000019, 23.932462607999966],
          [120.370810178000056, 23.932635899999966],
          [120.371082225, 23.932699575999987],
          [120.371712506000108, 23.932608310000013],
          [120.372478137000016, 23.932689642],
          [120.372953930000108, 23.932863623999975],
          [120.373156680000065, 23.933177246999989],
          [120.37339280500008, 23.933631755],
          [120.373540439000067, 23.93459471699996],
          [120.373547448000082, 23.935632165],
          [120.373601853000082, 23.936802250000014],
          [120.37364729300009, 23.93734321899999],
          [120.373811473000046, 23.938222608999961],
          [120.373930220000048, 23.938510034999965],
          [120.374722497000093, 23.941290176999974],
          [120.375410908000049, 23.943683782999969],
          [120.375381222000087, 23.944800212],
          [120.375901426000041, 23.948368679999977],
          [120.377262768000037, 23.953589234999964],
          [120.377526752000094, 23.955119782999962],
          [120.377758655000108, 23.957524697999972],
          [120.377838250000082, 23.95795192099999],
          [120.377907579000066, 23.958324043999976],
          [120.3779877730001, 23.95867542199997],
          [120.378528494000079, 23.959768369],
          [120.379285311000089, 23.961338618],
          [120.380264321000013, 23.963026453999976],
          [120.381213225999986, 23.96439686599999],
          [120.381566839000016, 23.964661577],
          [120.381921184000021, 23.964775836999983],
          [120.382262591000085, 23.96473960399998],
          [120.38298761100009, 23.964404009],
          [120.383603672000049, 23.96401782299999],
          [120.384136523000038, 23.963907128],
          [120.384888476000015, 23.963646847999975],
          [120.385312369000061, 23.963485562000013],
          [120.385627898000052, 23.96314831499999],
          [120.385849933000031, 23.96296206200001],
          [120.386414736, 23.962589804999979],
          [120.386901134000027, 23.962377741999976],
          [120.387349448999984, 23.96200500899999],
          [120.387448203000076, 23.961648727999986],
          [120.387437352, 23.961091253],
          [120.389476719000058, 23.9611781],
          [120.389919837000093, 23.961176839],
          [120.390083427000036, 23.961166653000017],
          [120.390261528, 23.961151140999988],
          [120.390305310000031, 23.961139719],
          [120.390329105000106, 23.96111782799999],
          [120.390343381000093, 23.961094033999981],
          [120.390338623000048, 23.961059770000013],
          [120.390312923999986, 23.96102169800001],
          [120.389782007, 23.960478628000018],
          [120.389657506000049, 23.960367349],
          [120.389550634000102, 23.960288020999979],
          [120.389389775000055, 23.96018004699997],
          [120.389076871000043, 23.960061054999958],
          [120.389000849000013, 23.960026899999978],
          [120.388924826000107, 23.959985033],
          [120.388870839000091, 23.959940962],
          [120.388819056000102, 23.959895789000011],
          [120.388586227, 23.959653860999989],
          [120.388536734000013, 23.959576528],
          [120.388493427000057, 23.95947754199999],
          [120.388409908000071, 23.959310502999955],
          [120.388276896000079, 23.958923839],
          [120.388233589000023, 23.958753707000014],
          [120.38820932200008, 23.958629179],
          [120.388177135000106, 23.958430091000018],
          [120.388059635000104, 23.95797848499999],
          [120.38659406799998, 23.958258008000016],
          [120.38390617900005, 23.958443207999988],
          [120.383095345000015, 23.958330642999986],
          [120.382589556000084, 23.95803797699999],
          [120.38207843400005, 23.957689469],
          [120.381846687, 23.95735725099999],
          [120.381794346000106, 23.957053243],
          [120.381906189, 23.956366735999989],
          [120.382394230000045, 23.953160785],
          [120.382694546000025, 23.951288205],
          [120.383141242000079, 23.948515434999965],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '文津村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-022',
      VILLAGE_ID: '022',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.371325568000088, 23.959812409999973],
          [120.372473404000033, 23.959816746999984],
          [120.372603033000019, 23.959821377000019],
          [120.374821179000037, 23.959775926],
          [120.374985376000041, 23.959740704],
          [120.375118536000045, 23.959662292],
          [120.376295442, 23.958561681999967],
          [120.376515, 23.958383127999962],
          [120.376679539000065, 23.958276127000016],
          [120.376867372000106, 23.958197932999987],
          [120.37723498199999, 23.958091754999973],
          [120.377838250000082, 23.95795192099999],
          [120.377758655000108, 23.957524697999972],
          [120.377526752000094, 23.955119782999962],
          [120.377262768000037, 23.953589234999964],
          [120.375901426000041, 23.948368679999977],
          [120.375381222000087, 23.944800212],
          [120.375410908000049, 23.943683782999969],
          [120.374722497000093, 23.941290176999974],
          [120.373930220000048, 23.938510034999965],
          [120.373811473000046, 23.938222608999961],
          [120.37364729300009, 23.93734321899999],
          [120.373601853000082, 23.936802250000014],
          [120.373547448000082, 23.935632165],
          [120.373540439000067, 23.93459471699996],
          [120.37339280500008, 23.933631755],
          [120.373156680000065, 23.933177246999989],
          [120.372953930000108, 23.932863623999975],
          [120.372478137000016, 23.932689642],
          [120.371712506000108, 23.932608310000013],
          [120.371082225, 23.932699575999987],
          [120.370810178000056, 23.932635899999966],
          [120.370504608000019, 23.932462607999966],
          [120.370251174000018, 23.93207058],
          [120.370118407000064, 23.93136624899999],
          [120.369956965000029, 23.929184110999973],
          [120.369902536000041, 23.926368729999961],
          [120.370011876000035, 23.92493638],
          [120.370291356000038, 23.922940567999984],
          [120.370016645000078, 23.922887645999985],
          [120.369486719000051, 23.922779577000021],
          [120.369117995999972, 23.922721586],
          [120.368764266000085, 23.922741325999972],
          [120.368633648, 23.922726667999985],
          [120.368541638000011, 23.922676862999968],
          [120.368518884000068, 23.922613231000014],
          [120.368488857000074, 23.922464846000015],
          [120.368412324000019, 23.922393930999977],
          [120.368358514000093, 23.922393710999959],
          [120.368197178000059, 23.922371863999988],
          [120.367981859000011, 23.922385109999976],
          [120.36790519200008, 23.922342439000015],
          [120.367813493000085, 23.922229096],
          [120.367721999000068, 23.92207338799999],
          [120.36765332700007, 23.921967209999988],
          [120.367523262000063, 23.921839588],
          [120.36733528000002, 23.921596865],
          [120.366883961000099, 23.921136091999969],
          [120.366692877000077, 23.920909382999969],
          [120.366371489000016, 23.920604475999983],
          [120.366233564000026, 23.920512125],
          [120.366132594000078, 23.920723517999985],
          [120.366023935000044, 23.920934868999982],
          [120.365838506000031, 23.921124739999957],
          [120.36565338900003, 23.921251063999971],
          [120.365522391000013, 23.921314062],
          [120.365368504, 23.921341669999986],
          [120.364991473000032, 23.921410722],
          [120.364706799000032, 23.921458971999975],
          [120.364506822000052, 23.92147933],
          [120.363568799000063, 23.921747583999988],
          [120.36330384900009, 23.92187895],
          [120.362935035000092, 23.921958371999985],
          [120.362710848999981, 23.921942729],
          [120.362262983000051, 23.921808398999964],
          [120.361870865000014, 23.921740543999977],
          [120.361647222000116, 23.921614507999976],
          [120.361009027000023, 23.921096703999972],
          [120.360753430000045, 23.920955820999982],
          [120.360577085000045, 23.920984523],
          [120.360400451000032, 23.921072093999989],
          [120.360222729000029, 23.92138045],
          [120.360001190000048, 23.921398581999973],
          [120.359707563000043, 23.921256259],
          [120.359299121000049, 23.921042906000011],
          [120.358787263000067, 23.921040772000019],
          [120.356482682000077, 23.921278061],
          [120.355944653000051, 23.92139339200002],
          [120.356007816000115, 23.92155827399999],
          [120.356350527999979, 23.92212410199999],
          [120.356653976000089, 23.922866135999975],
          [120.356727662000011, 23.923489634],
          [120.35672446, 23.924136317000023],
          [120.356796449000072, 23.924614801999983],
          [120.356846355000016, 23.924873696000013],
          [120.356742232000073, 23.925226000999988],
          [120.356676563000065, 23.925566713999988],
          [120.356675165000055, 23.92584891000001],
          [120.356430506000038, 23.926153595],
          [120.355943049000061, 23.926386718999982],
          [120.354378319000034, 23.92708564699999],
          [120.354005161000032, 23.927495617000019],
          [120.3537101820001, 23.927623713999974],
          [120.353274899000098, 23.927657154],
          [120.352343739000034, 23.927620197999975],
          [120.352064334000033, 23.928994444],
          [120.352041606000057, 23.929614641999965],
          [120.352040151000111, 23.92990617],
          [120.352355352000018, 23.930328619],
          [120.354346913000057, 23.93278855499999],
          [120.354501981000013, 23.93314141],
          [120.354620295000018, 23.933878337999978],
          [120.354578923000048, 23.935190943999984],
          [120.354663814000105, 23.93563956500002],
          [120.355023380000034, 23.936499784000013],
          [120.355724450000025, 23.937531299999964],
          [120.356160242000101, 23.938221494999986],
          [120.357039515000011, 23.939558986999977],
          [120.357667495000101, 23.940711770999986],
          [120.357695737000071, 23.941251464999969],
          [120.35752466100007, 23.941463736],
          [120.357075041000016, 23.941745845999989],
          [120.355001227, 23.942290929999988],
          [120.354538538000028, 23.942343220999984],
          [120.355097509000061, 23.944140936999972],
          [120.355340207000026, 23.944908488],
          [120.355859756000058, 23.94721025599998],
          [120.356236166000031, 23.947786736],
          [120.356879192000022, 23.948137847999973],
          [120.358431362000047, 23.948719241999957],
          [120.358960266000039, 23.949139556000016],
          [120.359222918, 23.949715554],
          [120.359390499000014, 23.95034341099999],
          [120.359497383000061, 23.951403220000024],
          [120.359245262000059, 23.951401253],
          [120.359251156000028, 23.953842213000019],
          [120.359254140000075, 23.95540826],
          [120.360963742000081, 23.960042720999976],
          [120.361025329000086, 23.960253329],
          [120.363963831000092, 23.959854736999976],
          [120.365638041000011, 23.959832376999973],
          [120.368428153000082, 23.959843879999983],
          [120.371325568000088, 23.959812409999973],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '建平村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-023',
      VILLAGE_ID: '023',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.401476748000022, 23.973613633999989],
          [120.401476552000076, 23.973612768999985],
          [120.401477114000031, 23.973491422999956],
          [120.401477131000107, 23.973487874999982],
          [120.401515773000028, 23.97340605899999],
          [120.401533140000069, 23.973328058999961],
          [120.401618476000053, 23.97325572399999],
          [120.401776245000079, 23.97281920499999],
          [120.402638450000026, 23.97140896599999],
          [120.402697102000019, 23.971223479999971],
          [120.402736653000034, 23.971002543999969],
          [120.402500906000014, 23.969873842000016],
          [120.402275340000074, 23.968601984],
          [120.402144850999989, 23.967655214999958],
          [120.402069180000012, 23.967354245],
          [120.401983545999983, 23.967123980999968],
          [120.401198363000063, 23.965603854999973],
          [120.400524917000098, 23.96439793],
          [120.400376762000064, 23.96413263],
          [120.400367622000076, 23.964026472999969],
          [120.400136935000091, 23.963919450999978],
          [120.399829189, 23.963812135999987],
          [120.399733274000027, 23.963723328],
          [120.39965695300009, 23.963563843000014],
          [120.399658142000021, 23.96330738899999],
          [120.399678350000059, 23.96310406600001],
          [120.399901370000066, 23.96278656399998],
          [120.400094795000072, 23.962619295],
          [120.400162672000079, 23.962522277999977],
          [120.400182076000092, 23.962409821999969],
          [120.399998280000091, 23.960498894],
          [120.399980246000041, 23.96023351699999],
          [120.400029431999982, 23.960012617],
          [120.400184573000061, 23.959792122999975],
          [120.400929147000042, 23.959070420999968],
          [120.401461491000077, 23.95851533499999],
          [120.401626134000026, 23.958321423000022],
          [120.401761963, 23.958109692999976],
          [120.401762100000028, 23.958109331999978],
          [120.40184957699999, 23.957880461999977],
          [120.40184971500004, 23.957880105],
          [120.40172971100003, 23.957873483999986],
          [120.398402278000049, 23.957689838999986],
          [120.398255306999971, 23.955658377],
          [120.398018490000027, 23.952730240999976],
          [120.397324929000092, 23.952745226999962],
          [120.396958638, 23.952805703],
          [120.396911798, 23.95252251399999],
          [120.396883192000018, 23.952460505000019],
          [120.396815855, 23.952187411999979],
          [120.396749710000108, 23.951913003999984],
          [120.396769675000073, 23.95176274499999],
          [120.396829937, 23.951223877],
          [120.396829978000028, 23.95122352],
          [120.396773631000087, 23.950913781999976],
          [120.396696785, 23.95086926299999],
          [120.395355154000057, 23.951474212999962],
          [120.394828818000065, 23.95184924800002],
          [120.394549006000034, 23.951954274999963],
          [120.394317725000064, 23.95197991],
          [120.393999758000064, 23.952005182999962],
          [120.393566129000078, 23.95204770600002],
          [120.393180286000074, 23.95217],
          [120.392784727000048, 23.952309935000013],
          [120.392533766000028, 23.952423912],
          [120.392446709000055, 23.952503160999967],
          [120.392291773000011, 23.952679432000018],
          [120.39207908800006, 23.952846615999988],
          [120.391499984999982, 23.953100799000019],
          [120.390594298000011, 23.951424441000015],
          [120.389788841000041, 23.950035661999983],
          [120.388749787000037, 23.948256415999985],
          [120.388646477000052, 23.948119400999961],
          [120.38850872, 23.947883160999986],
          [120.388262232000102, 23.947503518],
          [120.387919427000028, 23.94694685],
          [120.387668713000039, 23.946571053999982],
          [120.387472487000082, 23.94624184],
          [120.387271964000078, 23.945931941],
          [120.387066018000041, 23.945635265],
          [120.386827733, 23.945302017999985],
          [120.385847263000073, 23.945298127999969],
          [120.385804966, 23.945344324],
          [120.385778638000019, 23.945431884],
          [120.385748485000036, 23.945578588999968],
          [120.385688217000052, 23.945864279000023],
          [120.385653306000094, 23.946126881999977],
          [120.385555958000054, 23.94676276],
          [120.385534129, 23.946928821000022],
          [120.38550405, 23.947060066999974],
          [120.385440233000054, 23.947206645999977],
          [120.385317629000028, 23.947325938],
          [120.385212336, 23.947344838999971],
          [120.38489243000005, 23.94736289],
          [120.384732485000086, 23.947369977999962],
          [120.384517800000026, 23.947384575999973],
          [120.384328124000035, 23.947449505],
          [120.384189052000025, 23.947491446999987],
          [120.384129847000068, 23.947553043000021],
          [120.384112335000054, 23.947695941999978],
          [120.384116341000095, 23.947738458999989],
          [120.38416581099996, 23.947955034999982],
          [120.384228812000046, 23.948256486999956],
          [120.384212403000092, 23.948330353],
          [120.383141242000079, 23.948515434999965],
          [120.382694546000025, 23.951288205],
          [120.382394230000045, 23.953160785],
          [120.381906189, 23.956366735999989],
          [120.381794346000106, 23.957053243],
          [120.381846687, 23.95735725099999],
          [120.38207843400005, 23.957689469],
          [120.382589556000084, 23.95803797699999],
          [120.383095345000015, 23.958330642999986],
          [120.38390617900005, 23.958443207999988],
          [120.38659406799998, 23.958258008000016],
          [120.388059635000104, 23.95797848499999],
          [120.388177135000106, 23.958430091000018],
          [120.38820932200008, 23.958629179],
          [120.388233589000023, 23.958753707000014],
          [120.388276896000079, 23.958923839],
          [120.388409908000071, 23.959310502999955],
          [120.388493427000057, 23.95947754199999],
          [120.388536734000013, 23.959576528],
          [120.388586227, 23.959653860999989],
          [120.388819056000102, 23.959895789000011],
          [120.388870839000091, 23.959940962],
          [120.388924826000107, 23.959985033],
          [120.389000849000013, 23.960026899999978],
          [120.389076871000043, 23.960061054999958],
          [120.389389775000055, 23.96018004699997],
          [120.389550634000102, 23.960288020999979],
          [120.389657506000049, 23.960367349],
          [120.389782007, 23.960478628000018],
          [120.390312923999986, 23.96102169800001],
          [120.390338623000048, 23.961059770000013],
          [120.390343381000093, 23.961094033999981],
          [120.390329105000106, 23.96111782799999],
          [120.390305310000031, 23.961139719],
          [120.390261528, 23.961151140999988],
          [120.390083427000036, 23.961166653000017],
          [120.389919837000093, 23.961176839],
          [120.389476719000058, 23.9611781],
          [120.387437352, 23.961091253],
          [120.387448203000076, 23.961648727999986],
          [120.387349448999984, 23.96200500899999],
          [120.386901134000027, 23.962377741999976],
          [120.386414736, 23.962589804999979],
          [120.385849933000031, 23.96296206200001],
          [120.385627898000052, 23.96314831499999],
          [120.385312369000061, 23.963485562000013],
          [120.384888476000015, 23.963646847999975],
          [120.384136523000038, 23.963907128],
          [120.383603672000049, 23.96401782299999],
          [120.38298761100009, 23.964404009],
          [120.382262591000085, 23.96473960399998],
          [120.381921184000021, 23.964775836999983],
          [120.381566839000016, 23.964661577],
          [120.381213225999986, 23.96439686599999],
          [120.380264321000013, 23.963026453999976],
          [120.379285311000089, 23.961338618],
          [120.378528494000079, 23.959768369],
          [120.3779877730001, 23.95867542199997],
          [120.377907579000066, 23.958324043999976],
          [120.377838250000082, 23.95795192099999],
          [120.37723498199999, 23.958091754999973],
          [120.376867372000106, 23.958197932999987],
          [120.376679539000065, 23.958276127000016],
          [120.376515, 23.958383127999962],
          [120.376295442, 23.958561681999967],
          [120.375118536000045, 23.959662292],
          [120.374985376000041, 23.959740704],
          [120.374821179000037, 23.959775926],
          [120.372603033000019, 23.959821377000019],
          [120.372613944000022, 23.959883196000018],
          [120.372623711000074, 23.96018181899999],
          [120.372888182, 23.961119819000011],
          [120.373432462000096, 23.96214133],
          [120.37391165400004, 23.96271985699999],
          [120.374335844000029, 23.963081934999966],
          [120.37457083000001, 23.963165261000022],
          [120.375030783000028, 23.963084765],
          [120.376120491000052, 23.962574409999981],
          [120.376869097000053, 23.962124583999966],
          [120.377082152000057, 23.96210485399999],
          [120.377351011000087, 23.96213683699999],
          [120.377507388000012, 23.962250722],
          [120.37777871199999, 23.962536686],
          [120.378023762, 23.962856856000023],
          [120.378612300000086, 23.964012373999974],
          [120.379455738000047, 23.965776375999987],
          [120.380178794000017, 23.96726560799997],
          [120.380206872000016, 23.967796216],
          [120.38019858800007, 23.968398207],
          [120.380226480000047, 23.968679371999986],
          [120.38022427600005, 23.968725655],
          [120.380211052000035, 23.968747693999987],
          [120.380180198000048, 23.968762018999971],
          [120.380085429000033, 23.968775242999968],
          [120.38006559400003, 23.968787365000018],
          [120.380052370000044, 23.968808302],
          [120.380051268000088, 23.968840258999968],
          [120.380053472000085, 23.969014368999957],
          [120.380057880000109, 23.969048529],
          [120.380071103000091, 23.969105830999972],
          [120.380085808000089, 23.969142136],
          [120.380661891000031, 23.970195945999972],
          [120.380790508, 23.97045352199999],
          [120.380774044000063, 23.973243807999985],
          [120.380776555, 23.97327925899997],
          [120.380782623000087, 23.973304956999961],
          [120.380800469000064, 23.97332316],
          [120.380828337000025, 23.973329625],
          [120.382136622000075, 23.973340134],
          [120.382185661000108, 23.973366404999965],
          [120.382285490000029, 23.973585328],
          [120.382401081000012, 23.973937356],
          [120.382465367999984, 23.974075126999963],
          [120.382528683000032, 23.974174847000011],
          [120.382596746000061, 23.974295144999981],
          [120.382613256000013, 23.974353095999987],
          [120.382616121000055, 23.974459107],
          [120.382614211000032, 23.974531690999967],
          [120.382606570999982, 23.974577533999987],
          [120.382588126000087, 23.97463091399997],
          [120.382549267000044, 23.974690230000011],
          [120.382499604000031, 23.974761858999987],
          [120.382491009000091, 23.974795286],
          [120.382490054000087, 23.974847813999975],
          [120.382497672, 23.974892700999963],
          [120.382520515, 23.974985976000024],
          [120.382629018000117, 23.975199175999968],
          [120.382684902000051, 23.975334190999977],
          [120.382700402000054, 23.975410472000014],
          [120.382702306000056, 23.975498988000016],
          [120.382684626000014, 23.975608201999975],
          [120.382688621000057, 23.975801987999983],
          [120.38267263900002, 23.975905872999967],
          [120.382644670000118, 23.975979790999983],
          [120.382577443000045, 23.976121657000011],
          [120.382566973000053, 23.976159251999977],
          [120.382566020999988, 23.976193039999977],
          [120.382573160000106, 23.976226353],
          [120.382620697000107, 23.976359371999976],
          [120.382781680000122, 23.977087320999988],
          [120.382793140000089, 23.977160678],
          [120.382794386, 23.977201159],
          [120.382786912000029, 23.977245377000013],
          [120.382773211000071, 23.977316374999976],
          [120.382765115000083, 23.977378653],
          [120.382760755000049, 23.977419134999966],
          [120.382778816000041, 23.977556769999961],
          [120.38292778800006, 23.978268307999976],
          [120.38303499600012, 23.978925183999973],
          [120.384427997000088, 23.978775954],
          [120.384616372000096, 23.978780186999973],
          [120.384709502000078, 23.978803469],
          [120.384838613000042, 23.978809818999967],
          [120.385187848000086, 23.978765370999977],
          [120.385515962, 23.978743359],
          [120.387604711000108, 23.978778760999983],
          [120.388980322000066, 23.978690061999984],
          [120.38952357900007, 23.978557055999989],
          [120.39016786500008, 23.978413636000013],
          [120.39120329, 23.977939469000024],
          [120.39166455400003, 23.977784638999985],
          [120.392022599000043, 23.977607229999979],
          [120.392358064000064, 23.977410467],
          [120.392509668, 23.977294344000015],
          [120.392564503000017, 23.977233056999953],
          [120.392606437000026, 23.977162093999976],
          [120.392648177000055, 23.977126761],
          [120.392712882000069, 23.977100806999989],
          [120.392938676000085, 23.977042745999977],
          [120.393058328000038, 23.976981417999969],
          [120.393246113000018, 23.976734048],
          [120.393285836000018, 23.976699740999983],
          [120.39438726700007, 23.976439731000017],
          [120.394714084000029, 23.976289864],
          [120.394885619000107, 23.976244724000011],
          [120.395291280000023, 23.976107990999981],
          [120.395562469000083, 23.97597663399999],
          [120.395770097000081, 23.97585375200001],
          [120.396015862000013, 23.975652479],
          [120.396215016000028, 23.975457563],
          [120.396634510000027, 23.975150357],
          [120.396956546000055, 23.974989338999972],
          [120.39741071100002, 23.974847392],
          [120.398326235, 23.974714709],
          [120.399897801000066, 23.974350096],
          [120.400303858000029, 23.973836736999978],
          [120.401471057000094, 23.973614717000025],
          [120.401476748000022, 23.973613633999989],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '崙腳村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-024',
      VILLAGE_ID: '024',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.371325568000088, 23.959812409999973],
          [120.368428153000082, 23.959843879999983],
          [120.365638041000011, 23.959832376999973],
          [120.363963831000092, 23.959854736999976],
          [120.361025329000086, 23.960253329],
          [120.360497657, 23.96040843799999],
          [120.360431140000074, 23.960541255],
          [120.360585509000074, 23.961292112],
          [120.361933899000064, 23.96659026799999],
          [120.361931433, 23.967091238999988],
          [120.360751435, 23.967235268999985],
          [120.359481382000013, 23.967703868999973],
          [120.358650820000094, 23.96794902700001],
          [120.358207250000063, 23.96821797099998],
          [120.357555489000063, 23.968851621999971],
          [120.357317350999978, 23.969310984999986],
          [120.357147816000065, 23.97079967],
          [120.357137438, 23.972500484999987],
          [120.357869001000026, 23.973613828999962],
          [120.35858658700009, 23.974578161999982],
          [120.358775473, 23.975134092],
          [120.359168618999988, 23.976124146999982],
          [120.360044468000055, 23.97826156],
          [120.36068537300001, 23.979834872000012],
          [120.360907182, 23.980114339999975],
          [120.361125913, 23.980602689999987],
          [120.361723821000055, 23.98193209799999],
          [120.362338001000012, 23.982950142999968],
          [120.362749135000044, 23.983290350999969],
          [120.36305752400007, 23.98353535],
          [120.363203829000057, 23.983766141999965],
          [120.363378537, 23.984213682],
          [120.36377738200008, 23.984542575],
          [120.365399689000014, 23.985548753999957],
          [120.366351637000079, 23.985876329],
          [120.367273053000076, 23.986089545],
          [120.36785362, 23.986183584],
          [120.368790694000054, 23.986253307],
          [120.369026272000056, 23.986263683999983],
          [120.36947093600007, 23.985816385999986],
          [120.37052251, 23.985254998999984],
          [120.371005744000058, 23.98516524299998],
          [120.371820015000011, 23.985148094],
          [120.37184436400004, 23.982313190999985],
          [120.371845959000098, 23.980313731],
          [120.371824528000047, 23.980234382999967],
          [120.371812627000054, 23.979536156999973],
          [120.37184833100001, 23.97772711899999],
          [120.371841428000039, 23.977198324],
          [120.371844998000029, 23.977172745],
          [120.371855705000016, 23.97715549399998],
          [120.371870577000081, 23.977144192],
          [120.371896156000048, 23.977140027],
          [120.372111468000057, 23.977135168999983],
          [120.372173877000023, 23.977120767],
          [120.37219468, 23.977099963999983],
          [120.372205882, 23.977072759999984],
          [120.372210683000048, 23.977032753999968],
          [120.37220323699999, 23.976186574999964],
          [120.372190388000035, 23.97615944899999],
          [120.372160883000106, 23.976147551999976],
          [120.372133757000029, 23.97614279299999],
          [120.371890576000069, 23.97614279299999],
          [120.37184822100005, 23.976136606],
          [120.371827282000027, 23.976119474],
          [120.371813957000086, 23.97606665],
          [120.371819683, 23.975543006999988],
          [120.371954398000071, 23.974996336999975],
          [120.371958303000014, 23.974191951000016],
          [120.371942684, 23.974106046000017],
          [120.371915350000094, 23.97406699799999],
          [120.37187239800005, 23.974031855000014],
          [120.371809921000036, 23.973986949999968],
          [120.371733804000073, 23.97390968500001],
          [120.371574856, 23.973711713999965],
          [120.371534881, 23.97367078799999],
          [120.371495586000052, 23.973649185999967],
          [120.371444824000037, 23.973635519000013],
          [120.371343299, 23.9736199],
          [120.371279922000085, 23.973593781000016],
          [120.371212489000072, 23.973543757],
          [120.371146108000048, 23.973479327999968],
          [120.370974297000089, 23.97327823199997],
          [120.370866915000065, 23.973174755],
          [120.370767343, 23.973120088000016],
          [120.370427627000012, 23.972956086999975],
          [120.370413960000064, 23.972795990999977],
          [120.370343674000097, 23.972448464999989],
          [120.370154292000052, 23.971878365999981],
          [120.369992244000045, 23.971464458999986],
          [120.36979700400002, 23.970829931000015],
          [120.36962714600007, 23.970039212],
          [120.369535384000073, 23.969814686999971],
          [120.369471748, 23.969693283],
          [120.369402621000063, 23.969539400000016],
          [120.369349907000014, 23.969373446999988],
          [120.369115619000013, 23.968344536],
          [120.368490854000029, 23.968346488],
          [120.36783289800006, 23.968319155],
          [120.367495134000038, 23.96730976799999],
          [120.367213989000106, 23.96661081099999],
          [120.371977500000057, 23.962379256999984],
          [120.371952893000056, 23.96232411399999],
          [120.371325568000088, 23.959812409999973],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '新生村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-025',
      VILLAGE_ID: '025',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.401960848000044, 23.983461528],
          [120.401879983000086, 23.983347163],
          [120.401850578000122, 23.98322121599999],
          [120.401851159000103, 23.983095378],
          [120.401921076999983, 23.982796781999973],
          [120.401947414, 23.982659251],
          [120.401995208000017, 23.982513921999988],
          [120.402177682, 23.98207127799996],
          [120.402238742, 23.981835553999971],
          [120.402252210000029, 23.981701911],
          [120.40227898099999, 23.981469998999984],
          [120.402318515000033, 23.981257792999966],
          [120.402397233000102, 23.98090810699999],
          [120.402476222000033, 23.980547298],
          [120.402537861000042, 23.980185752999983],
          [120.402539475000012, 23.979835757999961],
          [120.402553268, 23.979631326],
          [120.402588318000099, 23.979462361999985],
          [120.402657615000052, 23.979297469],
          [120.402684114000081, 23.97912454299999],
          [120.402714916000036, 23.97895243899999],
          [120.402724190000072, 23.978799112999955],
          [120.402725386000029, 23.978539570999981],
          [120.402713152000032, 23.978405827999989],
          [120.402666938000053, 23.978209016999973],
          [120.402633341000055, 23.978063387999981],
          [120.402553404000059, 23.977748469999977],
          [120.402481872000052, 23.977468988999966],
          [120.402401160000053, 23.977260693999977],
          [120.402321062000055, 23.976981168999977],
          [120.402228837000052, 23.976544308000019],
          [120.402132130000027, 23.976150679999986],
          [120.402081478999975, 23.975947323],
          [120.401971106000019, 23.975730605999988],
          [120.401954481000075, 23.975620429999971],
          [120.40192135700012, 23.975372554999961],
          [120.401884587000055, 23.975247753],
          [120.401831770000044, 23.975105182999972],
          [120.401821506000033, 23.975011870999985],
          [120.401821846000075, 23.974938237999968],
          [120.401790443000095, 23.974790838999972],
          [120.401726977000052, 23.974638411999972],
          [120.401651801000071, 23.974331646999975],
          [120.401593216000038, 23.97412845],
          [120.401476748000022, 23.973613633999989],
          [120.401471057000094, 23.973614717000025],
          [120.400303858000029, 23.973836736999978],
          [120.399897801000066, 23.974350096],
          [120.398326235, 23.974714709],
          [120.39741071100002, 23.974847392],
          [120.396956546000055, 23.974989338999972],
          [120.396634510000027, 23.975150357],
          [120.396215016000028, 23.975457563],
          [120.396015862000013, 23.975652479],
          [120.395770097000081, 23.97585375200001],
          [120.395562469000083, 23.97597663399999],
          [120.395291280000023, 23.976107990999981],
          [120.394885619000107, 23.976244724000011],
          [120.394714084000029, 23.976289864],
          [120.39438726700007, 23.976439731000017],
          [120.393285836000018, 23.976699740999983],
          [120.393246113000018, 23.976734048],
          [120.393058328000038, 23.976981417999969],
          [120.392938676000085, 23.977042745999977],
          [120.392712882000069, 23.977100806999989],
          [120.392648177000055, 23.977126761],
          [120.392606437000026, 23.977162093999976],
          [120.392564503000017, 23.977233056999953],
          [120.392509668, 23.977294344000015],
          [120.392358064000064, 23.977410467],
          [120.392022599000043, 23.977607229999979],
          [120.39166455400003, 23.977784638999985],
          [120.39120329, 23.977939469000024],
          [120.39016786500008, 23.978413636000013],
          [120.38952357900007, 23.978557055999989],
          [120.388980322000066, 23.978690061999984],
          [120.387604711000108, 23.978778760999983],
          [120.385515962, 23.978743359],
          [120.385187848000086, 23.978765370999977],
          [120.384838613000042, 23.978809818999967],
          [120.384709502000078, 23.978803469],
          [120.384616372000096, 23.978780186999973],
          [120.384427997000088, 23.978775954],
          [120.38303499600012, 23.978925183999973],
          [120.38292778800006, 23.978268307999976],
          [120.382778816000041, 23.977556769999961],
          [120.382760755000049, 23.977419134999966],
          [120.382765115000083, 23.977378653],
          [120.382773211000071, 23.977316374999976],
          [120.382786912000029, 23.977245377000013],
          [120.382794386, 23.977201159],
          [120.382793140000089, 23.977160678],
          [120.382781680000122, 23.977087320999988],
          [120.382620697000107, 23.976359371999976],
          [120.382573160000106, 23.976226353],
          [120.382566020999988, 23.976193039999977],
          [120.382566973000053, 23.976159251999977],
          [120.382577443000045, 23.976121657000011],
          [120.382644670000118, 23.975979790999983],
          [120.38267263900002, 23.975905872999967],
          [120.382688621000057, 23.975801987999983],
          [120.382684626000014, 23.975608201999975],
          [120.382702306000056, 23.975498988000016],
          [120.382700402000054, 23.975410472000014],
          [120.382684902000051, 23.975334190999977],
          [120.382629018000117, 23.975199175999968],
          [120.382520515, 23.974985976000024],
          [120.382497672, 23.974892700999963],
          [120.382490054000087, 23.974847813999975],
          [120.382491009000091, 23.974795286],
          [120.382499604000031, 23.974761858999987],
          [120.382549267000044, 23.974690230000011],
          [120.382588126000087, 23.97463091399997],
          [120.382606570999982, 23.974577533999987],
          [120.382614211000032, 23.974531690999967],
          [120.382616121000055, 23.974459107],
          [120.382613256000013, 23.974353095999987],
          [120.382596746000061, 23.974295144999981],
          [120.382528683000032, 23.974174847000011],
          [120.382465367999984, 23.974075126999963],
          [120.382401081000012, 23.973937356],
          [120.382285490000029, 23.973585328],
          [120.382185661000108, 23.973366404999965],
          [120.382136622000075, 23.973340134],
          [120.380828337000025, 23.973329625],
          [120.380800469000064, 23.97332316],
          [120.380782623000087, 23.973304956999961],
          [120.380776555, 23.97327925899997],
          [120.380774044000063, 23.973243807999985],
          [120.380790508, 23.97045352199999],
          [120.380661891000031, 23.970195945999972],
          [120.380085808000089, 23.969142136],
          [120.380071103000091, 23.969105830999972],
          [120.380057880000109, 23.969048529],
          [120.380053472000085, 23.969014368999957],
          [120.380051268000088, 23.968840258999968],
          [120.380052370000044, 23.968808302],
          [120.38006559400003, 23.968787365000018],
          [120.380085429000033, 23.968775242999968],
          [120.380180198000048, 23.968762018999971],
          [120.380211052000035, 23.968747693999987],
          [120.38022427600005, 23.968725655],
          [120.380226480000047, 23.968679371999986],
          [120.38019858800007, 23.968398207],
          [120.380206872000016, 23.967796216],
          [120.380178794000017, 23.96726560799997],
          [120.379455738000047, 23.965776375999987],
          [120.378612300000086, 23.964012373999974],
          [120.378023762, 23.962856856000023],
          [120.37777871199999, 23.962536686],
          [120.377507388000012, 23.962250722],
          [120.377351011000087, 23.96213683699999],
          [120.377082152000057, 23.96210485399999],
          [120.376869097000053, 23.962124583999966],
          [120.376120491000052, 23.962574409999981],
          [120.375030783000028, 23.963084765],
          [120.37457083000001, 23.963165261000022],
          [120.374335844000029, 23.963081934999966],
          [120.37391165400004, 23.96271985699999],
          [120.373432462000096, 23.96214133],
          [120.372888182, 23.961119819000011],
          [120.372623711000074, 23.96018181899999],
          [120.372613944000022, 23.959883196000018],
          [120.372603033000019, 23.959821377000019],
          [120.372473404000033, 23.959816746999984],
          [120.371325568000088, 23.959812409999973],
          [120.371952893000056, 23.96232411399999],
          [120.371977500000057, 23.962379256999984],
          [120.367213989000106, 23.96661081099999],
          [120.367495134000038, 23.96730976799999],
          [120.36783289800006, 23.968319155],
          [120.368490854000029, 23.968346488],
          [120.369115619000013, 23.968344536],
          [120.369349907000014, 23.969373446999988],
          [120.369402621000063, 23.969539400000016],
          [120.369471748, 23.969693283],
          [120.369535384000073, 23.969814686999971],
          [120.36962714600007, 23.970039212],
          [120.36979700400002, 23.970829931000015],
          [120.369992244000045, 23.971464458999986],
          [120.370154292000052, 23.971878365999981],
          [120.370343674000097, 23.972448464999989],
          [120.370413960000064, 23.972795990999977],
          [120.370427627000012, 23.972956086999975],
          [120.370767343, 23.973120088000016],
          [120.370866915000065, 23.973174755],
          [120.370974297000089, 23.97327823199997],
          [120.371146108000048, 23.973479327999968],
          [120.371212489000072, 23.973543757],
          [120.371279922000085, 23.973593781000016],
          [120.371343299, 23.9736199],
          [120.371444824000037, 23.973635519000013],
          [120.371495586000052, 23.973649185999967],
          [120.371534881, 23.97367078799999],
          [120.371574856, 23.973711713999965],
          [120.371733804000073, 23.97390968500001],
          [120.371809921000036, 23.973986949999968],
          [120.37187239800005, 23.974031855000014],
          [120.371915350000094, 23.97406699799999],
          [120.371942684, 23.974106046000017],
          [120.371958303000014, 23.974191951000016],
          [120.371954398000071, 23.974996336999975],
          [120.371819683, 23.975543006999988],
          [120.371813957000086, 23.97606665],
          [120.371827282000027, 23.976119474],
          [120.37184822100005, 23.976136606],
          [120.371890576000069, 23.97614279299999],
          [120.372133757000029, 23.97614279299999],
          [120.372160883000106, 23.976147551999976],
          [120.372190388000035, 23.97615944899999],
          [120.37220323699999, 23.976186574999964],
          [120.372210683000048, 23.977032753999968],
          [120.372205882, 23.977072759999984],
          [120.37219468, 23.977099963999983],
          [120.372173877000023, 23.977120767],
          [120.372111468000057, 23.977135168999983],
          [120.371896156000048, 23.977140027],
          [120.371870577000081, 23.977144192],
          [120.371855705000016, 23.97715549399998],
          [120.371844998000029, 23.977172745],
          [120.371841428000039, 23.977198324],
          [120.37184833100001, 23.97772711899999],
          [120.371812627000054, 23.979536156999973],
          [120.371824528000047, 23.980234382999967],
          [120.371845959000098, 23.980313731],
          [120.37184436400004, 23.982313190999985],
          [120.371820015000011, 23.985148094],
          [120.371005744000058, 23.98516524299998],
          [120.37052251, 23.985254998999984],
          [120.36947093600007, 23.985816385999986],
          [120.369026272000056, 23.986263683999983],
          [120.367997104000096, 23.987614485999966],
          [120.367988813, 23.987927485999968],
          [120.36811078900007, 23.988222683999975],
          [120.368752569000108, 23.988123430000023],
          [120.368933641999988, 23.988124174999982],
          [120.36906097399999, 23.988158347],
          [120.369631925, 23.98852559599996],
          [120.371054229000052, 23.989632067],
          [120.373894798000038, 23.991995654999968],
          [120.37536655200006, 23.993302453],
          [120.37655797900004, 23.994189066999965],
          [120.376774016, 23.994282723000012],
          [120.37759645200002, 23.994319188999985],
          [120.378671748000073, 23.994297045999971],
          [120.380784003000031, 23.994289057999978],
          [120.382186652000073, 23.994152585999974],
          [120.383536131000028, 23.99399577500002],
          [120.38459888, 23.993902951999956],
          [120.386106808000036, 23.99374930499998],
          [120.38696786199999, 23.993678879],
          [120.387386327000058, 23.993643610999957],
          [120.388296803, 23.99351348399999],
          [120.389192063, 23.993349114999983],
          [120.391168537, 23.99290134300001],
          [120.392370654000047, 23.992636612],
          [120.393706527000063, 23.99226845299999],
          [120.395460081, 23.991808798000012],
          [120.396453001000054, 23.99154408899998],
          [120.396653307000079, 23.991426942000011],
          [120.396903925000061, 23.991231381000024],
          [120.397423204999981, 23.99080869299999],
          [120.39814860200012, 23.990264942999982],
          [120.398813131, 23.989628544999988],
          [120.399469172000067, 23.989077548999987],
          [120.399899294000093, 23.988649828],
          [120.400230312000076, 23.988177042],
          [120.400406414000017, 23.987862141999969],
          [120.400651879000037, 23.987164679999967],
          [120.40118999700006, 23.985801606999964],
          [120.40142764000008, 23.98501727099999],
          [120.401960848000044, 23.983461528],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    properties: {
      COUNTY: '彰化縣',
      TOWN: '芳苑鄉',
      VILLAGE: '漢寶村',
      COUNTY_ID: '10007',
      TOWN_ID: '10007230',
      V_ID: '10007230-026',
      VILLAGE_ID: '026',
    },
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [120.37132933800001, 24.03844839],
          [120.371823573000029, 24.03831124],
          [120.374096054999981, 24.03769417199997],
          [120.37432809400002, 24.037172864],
          [120.374661968000055, 24.036475072000016],
          [120.37487236700008, 24.036077734999964],
          [120.375059663, 24.035730289999989],
          [120.37515112200002, 24.035583062999965],
          [120.375221991000103, 24.035428177],
          [120.37524701400001, 24.035371511999973],
          [120.375289378000062, 24.035140817999981],
          [120.375331796000069, 24.034898766],
          [120.375420797000061, 24.034529699999986],
          [120.375454562000073, 24.034370878999976],
          [120.375492124000061, 24.034280198000015],
          [120.375580060000061, 24.03400805599998],
          [120.375646860000074, 24.033841803000016],
          [120.375789356000055, 24.033491646],
          [120.37594363200003, 24.033147857],
          [120.376101903000048, 24.032830584],
          [120.376264350000042, 24.032501969],
          [120.376347682000073, 24.03232820800001],
          [120.376573431, 24.031822977999965],
          [120.37674814099999, 24.031517129999987],
          [120.376939439, 24.031192406999967],
          [120.377064125000061, 24.030996113],
          [120.377243684000064, 24.030691385999987],
          [120.377347782000015, 24.03048743399999],
          [120.377418702, 24.030321178999969],
          [120.377448066000042, 24.030219115000012],
          [120.377464929000084, 24.030143491999961],
          [120.377477739000028, 24.03005271],
          [120.377540535000094, 24.029859939999977],
          [120.377573860000084, 24.029791949999971],
          [120.377627807000067, 24.029724044000012],
          [120.377797422000043, 24.029618766999967],
          [120.378034305000028, 24.029522591999953],
          [120.378253322000063, 24.029436448999988],
          [120.378344316000053, 24.029383816999989],
          [120.378464289000036, 24.029308612],
          [120.378555429, 24.029225724],
          [120.37862193, 24.029120018],
          [120.378672060000099, 24.028987754999989],
          [120.378697261000056, 24.02889324],
          [120.378689541000085, 24.028783448999988],
          [120.37863298100001, 24.02853721100001],
          [120.378634010999988, 24.028356189],
          [120.378651290000079, 24.02819351700003],
          [120.37869277199999, 24.028144484999967],
          [120.378747842000038, 24.02812856399996],
          [120.378874006000046, 24.027957892],
          [120.378932639000013, 24.027888586],
          [120.37898924600006, 24.02786382299999],
          [120.379152866000027, 24.027784244000021],
          [120.379255118000046, 24.027736505],
          [120.379386471000075, 24.027699584999983],
          [120.379485602000031, 24.027694640999972],
          [120.379567168000108, 24.027705670999971],
          [120.379736337000054, 24.027684956],
          [120.379829690000065, 24.02766929],
          [120.379893947000028, 24.027642795999981],
          [120.380095435000044, 24.027568713999976],
          [120.380302817000029, 24.027481284],
          [120.3804588590001, 24.027413473999989],
          [120.380643037000013, 24.027301859000023],
          [120.380777520000038, 24.027219488],
          [120.381081746000049, 24.026996035],
          [120.381251514000056, 24.026849598999977],
          [120.381374450000067, 24.02674310899998],
          [120.381513256000062, 24.026581576999984],
          [120.381607145000089, 24.02645357],
          [120.381715841000087, 24.026277470000014],
          [120.38173652600004, 24.026218701999984],
          [120.38178086399999, 24.02609048499998],
          [120.381825382000059, 24.025924817000014],
          [120.381852025000057, 24.025839335999976],
          [120.381872988000069, 24.025733057000011],
          [120.381879473000026, 24.02559667],
          [120.381903238000078, 24.025503151999978],
          [120.381941578999985, 24.025409682000028],
          [120.381971010000015, 24.02535095699999],
          [120.382041412000035, 24.025257618],
          [120.382079640000029, 24.025188228999955],
          [120.382211346000076, 24.025076418999987],
          [120.38231096200002, 24.02496981599999],
          [120.382399710000058, 24.024842807],
          [120.382481888000029, 24.024725443000012],
          [120.382526135000049, 24.024615961999974],
          [120.382570317000031, 24.024519843999983],
          [120.382620405000026, 24.024407694999955],
          [120.382679354000061, 24.024271510999977],
          [120.382723460000079, 24.02419144600001],
          [120.382840910000027, 24.024012707999969],
          [120.382882719999984, 24.023965473000018],
          [120.382960991000019, 24.023892822999962],
          [120.383104457000059, 24.023759659999975],
          [120.383146274000069, 24.023744974999975],
          [120.383210090000034, 24.023701404999969],
          [120.383299388000069, 24.02362017599999],
          [120.383356700000036, 24.023553465],
          [120.38339814299999, 24.023467853999975],
          [120.383423748000041, 24.023357078999979],
          [120.383440207000021, 24.023257282000021],
          [120.383462975000043, 24.023198864999969],
          [120.38349928600006, 24.023120681999984],
          [120.383553471000013, 24.02306318599999],
          [120.383616735999979, 24.02298511199999],
          [120.383684417000026, 24.02292354199998],
          [120.383792883000069, 24.022787935999968],
          [120.383860700000014, 24.022697509999976],
          [120.38395107699999, 24.022586571000023],
          [120.384014520000036, 24.02247139699999],
          [120.384023856, 24.022397231999989],
          [120.384033293, 24.022302446000015],
          [120.384033922000057, 24.022170521999989],
          [120.384021073000099, 24.022038553999987],
          [120.384012598000027, 24.021931335000023],
          [120.384026369000026, 24.021869549000016],
          [120.384067271000035, 24.021770780999969],
          [120.384131969, 24.02171454399999],
          [120.384326119000093, 24.021509189],
          [120.384357998000041, 24.021418617999959],
          [120.384412416000018, 24.021311659999959],
          [120.384444607000091, 24.021155132999976],
          [120.384471914000073, 24.021081030999976],
          [120.384503790000053, 24.02099047],
          [120.384553618000041, 24.020904098],
          [120.384657315000027, 24.020826186],
          [120.38480142099999, 24.020752554],
          [120.384932069, 24.02067475],
          [120.385081099000118, 24.020510446999985],
          [120.38519972000006, 24.02037266],
          [120.385357850000105, 24.020183645000028],
          [120.385538638000057, 24.019953510999962],
          [120.385588365000103, 24.019887751999974],
          [120.385611199000095, 24.019809515],
          [120.385629657000095, 24.01970653],
          [120.385625636000086, 24.019607563],
          [120.385581631000036, 24.019413628999967],
          [120.385519884000018, 24.019150613],
          [120.385524826000051, 24.019055816999963],
          [120.385534163000102, 24.018981651999972],
          [120.385566137000069, 24.018870468999953],
          [120.385629771000026, 24.01871406699999],
          [120.385648190000055, 24.018619316],
          [120.385680341000025, 24.018471040999977],
          [120.385680870000101, 24.018359731000015],
          [120.385676846000024, 24.018260782],
          [120.38565958299999, 24.018112299999956],
          [120.385651184000039, 24.017988592999977],
          [120.385624436000072, 24.0179079],
          [120.38559349800002, 24.017800598999973],
          [120.38556246600001, 24.01771390299999],
          [120.385558326000023, 24.017639674999987],
          [120.385545300000103, 24.017544806999958],
          [120.385532450000028, 24.017412839000016],
          [120.385537452000108, 24.01730567299999],
          [120.385578761000033, 24.017120324],
          [120.385601553000015, 24.017050330999982],
          [120.38573264700004, 24.016877703],
          [120.385813938000069, 24.016787339999986],
          [120.38594475900004, 24.016672435000014],
          [120.386026982000104, 24.016625479],
          [120.3861125090001, 24.01658872],
          [120.386234032000047, 24.016539726999977],
          [120.386395769000046, 24.01653624799999],
          [120.386494577, 24.01654077],
          [120.386665279, 24.016541452999974],
          [120.386782133, 24.01652955099999],
          [120.386921506000022, 24.016505378000026],
          [120.387015941000072, 24.016485141000018],
          [120.387155607000068, 24.016399119],
          [120.387254707, 24.016341800999989],
          [120.387376386000028, 24.016259831999982],
          [120.387445152000041, 24.016180243999987],
          [120.387535306, 24.016114636999983],
          [120.387603391000084, 24.015966504999977],
          [120.387626376000071, 24.015855283999986],
          [120.387631552, 24.01571101799998],
          [120.387646141000019, 24.015476090999968],
          [120.387646765000014, 24.015344177000017],
          [120.387660825000012, 24.01522054199999],
          [120.387675786000045, 24.014907296999958],
          [120.387676351000096, 24.014787743999964],
          [120.38766804300009, 24.014665056999974],
          [120.387632866000089, 24.014504143],
          [120.387624271000064, 24.01442166299999],
          [120.387588801000092, 24.014322578],
          [120.387566829000079, 24.014219422999972],
          [120.38754093, 24.013996704],
          [120.387532375000092, 24.013905970999971],
          [120.387532823000029, 24.013811157],
          [120.387546747000059, 24.013716396999982],
          [120.38758758499999, 24.013629987999977],
          [120.387646431, 24.013535397999977],
          [120.387696135000056, 24.01347376499999],
          [120.387772713000018, 24.013428717],
          [120.387844760999954, 24.013391893999984],
          [120.388056064, 24.013355637],
          [120.388146966, 24.013328199999965],
          [120.388237039000046, 24.01327908799998],
          [120.38828668400005, 24.013229824],
          [120.388332170000027, 24.013110440999966],
          [120.388355058, 24.013019834],
          [120.388368923000016, 24.012937443999967],
          [120.388410189000069, 24.012760337000014],
          [120.388415032, 24.012686153999979],
          [120.388411725000083, 24.012434669000012],
          [120.388443696000081, 24.012323483999968],
          [120.38847558799999, 24.012228785999973],
          [120.38849414000002, 24.012105188],
          [120.388494664000035, 24.011993886000013],
          [120.388472536000108, 24.011923712999973],
          [120.388400608000097, 24.011834243999974],
          [120.388320649000079, 24.011644293999982],
          [120.388227036000117, 24.011491389],
          [120.388164928000037, 24.011326231999973],
          [120.38815184200007, 24.011243733999979],
          [120.388161274000026, 24.011148945999985],
          [120.388179650000097, 24.011062448],
          [120.388234002000118, 24.010967848999986],
          [120.388279271000101, 24.01089382799999],
          [120.38834250900004, 24.010819877999985],
          [120.388423540000076, 24.0107831],
          [120.388513534000026, 24.010750466999962],
          [120.388639559000012, 24.010697371999953],
          [120.388747465000037, 24.010677197],
          [120.388909058000081, 24.010702572],
          [120.389061532000028, 24.01075676899999],
          [120.389151098000085, 24.01081484],
          [120.389224837000029, 24.010842582999977],
          [120.389314599000045, 24.010859438],
          [120.389507810000055, 24.010847837000011],
          [120.389620322000027, 24.010802930999983],
          [120.389714926, 24.01074559299999],
          [120.389890422, 24.010680324],
          [120.390056933000096, 24.01061502899999],
          [120.390250377000029, 24.010553966000018],
          [120.390344901000049, 24.010513106],
          [120.390448431000095, 24.01046817199999],
          [120.39051611800005, 24.010402473999974],
          [120.390588338000043, 24.01032856],
          [120.390606946000062, 24.01019259],
          [120.390589617000046, 24.010056468999981],
          [120.390540401000067, 24.010015064],
          [120.390477921000084, 24.009928242999962],
          [120.390388549000022, 24.00982893699999],
          [120.390348278000033, 24.009795792000023],
          [120.390223517000081, 24.009549196],
          [120.390134397, 24.009396310999971],
          [120.390089866000011, 24.009313678],
          [120.390063168000054, 24.009259982999968],
          [120.390036838, 24.009127953000011],
          [120.390042087000111, 24.008967198999954],
          [120.390042571000095, 24.008864141999968],
          [120.390042940000058, 24.008785815],
          [120.390025420000015, 24.008690919999985],
          [120.389972331000081, 24.008517563999963],
          [120.389919244, 24.008344209],
          [120.389843631000062, 24.00817604599999],
          [120.389759023000011, 24.008019051999984],
          [120.38973687500004, 24.007953004999976],
          [120.38972833800004, 24.00785815499999],
          [120.389737845999974, 24.00774689],
          [120.389747159000081, 24.007676842],
          [120.390045347000054, 24.007311118],
          [120.39009504900001, 24.00724947399997],
          [120.39019869000002, 24.007179800999978],
          [120.390302156000061, 24.007147229999983],
          [120.390464191000092, 24.007077788999968],
          [120.390819624000059, 24.006955519],
          [120.391006030000085, 24.006879737],
          [120.391104986000073, 24.006851272999981],
          [120.391230872000051, 24.00682704199998],
          [120.391379218, 24.00680288199997],
          [120.39155900600008, 24.006778864999976],
          [120.391774807000033, 24.00673849299999],
          [120.391873722000028, 24.006718271999986],
          [120.392004081000096, 24.006698167000017],
          [120.392139259000018, 24.00660801299999],
          [120.392206888000032, 24.006554682999973],
          [120.39229705400011, 24.006484955999984],
          [120.392427894000093, 24.006361801],
          [120.392522743000072, 24.006250865000013],
          [120.39262634400005, 24.006189434],
          [120.392707313000074, 24.006165023999969],
          [120.392945628000021, 24.006112371000018],
          [120.393107562000054, 24.006063549000014],
          [120.39338026900009, 24.005942381999983],
          [120.39372255, 24.005749969000014],
          [120.394055712000053, 24.005586385],
          [120.394294525000092, 24.005426545000027],
          [120.394465713000045, 24.005320035999983],
          [120.394609796000054, 24.005246402999983],
          [120.394763168000026, 24.005106828999985],
          [120.394898557000019, 24.004971328999989],
          [120.395007051000107, 24.004823335],
          [120.395106617, 24.004662952999954],
          [120.395166917000111, 24.004545251999989],
          [120.395221223, 24.004458892999981],
          [120.395315856000025, 24.004393308000022],
          [120.39553180300004, 24.00431994],
          [120.39571158900003, 24.004295916999958],
          [120.395895826000014, 24.004280155999979],
          [120.396003723000035, 24.004259966999971],
          [120.396291537000025, 24.004186888999961],
          [120.39646684700007, 24.004158721999985],
          [120.396671409000049, 24.004091744999975],
          [120.396828943000045, 24.004022289000023],
          [120.397017922000032, 24.003952947],
          [120.397197973000075, 24.003871191000016],
          [120.39737366599999, 24.003760579],
          [120.397445743000048, 24.003715516999968],
          [120.397531450000059, 24.003637524999959],
          [120.397554139000022, 24.003588142999984],
          [120.397576865, 24.003530517999963],
          [120.397743842000068, 24.003362146000018],
          [120.397888188000024, 24.003230786999978],
          [120.397955775, 24.003185707999975],
          [120.398108701000069, 24.003140953999974],
          [120.398239209000039, 24.00308786899999],
          [120.398423502000014, 24.003059734000022],
          [120.398621382000087, 24.003006914],
          [120.398798463000034, 24.002956873],
          [120.398929028, 24.002891426000012],
          [120.399081935000012, 24.00285079799999],
          [120.39917631700007, 24.002838798],
          [120.399364928000068, 24.002847780000014],
          [120.399468216000059, 24.002852302],
          [120.399710767000116, 24.002853252000016],
          [120.399773746000051, 24.002832885],
          [120.399962338000023, 24.002845992999962],
          [120.400162193000014, 24.002868959999983],
          [120.400350689000092, 24.002902681],
          [120.400548133000029, 24.002944681000017],
          [120.400646831999978, 24.002969797999956],
          [120.400718490000017, 24.003015423],
          [120.400861957000089, 24.003073697999962],
          [120.40091132799999, 24.003082135999982],
          [120.401001028, 24.00311135199999],
          [120.401090689000043, 24.003148802999974],
          [120.40123436600004, 24.003161717],
          [120.401373475000014, 24.003191117],
          [120.401476650000063, 24.003220377999959],
          [120.401674074000042, 24.003266502000017],
          [120.401759338000033, 24.003283322],
          [120.401867063000054, 24.003300229999965],
          [120.40204221899999, 24.003305039999972],
          [120.402235361000081, 24.003305784],
          [120.402442074000078, 24.003285976000015],
          [120.402674300000044, 24.003253535999974],
          [120.40285859399999, 24.003225386999976],
          [120.402930555000026, 24.003205054000013],
          [120.403205021000076, 24.003103063],
          [120.403294948000052, 24.003082797999969],
          [120.403411846000026, 24.003058522999964],
          [120.403587058000085, 24.003050952000017],
          [120.403775859, 24.00301870199999],
          [120.403879301000075, 24.002990247],
          [120.403973796000059, 24.002953513000012],
          [120.404126968999989, 24.002855156999978],
          [120.404280213000106, 24.00274032299999],
          [120.40442889400002, 24.002641948999987],
          [120.404622355000015, 24.002572623999956],
          [120.404718723000087, 24.002537666999988],
          [120.404808708000019, 24.002505033000016],
          [120.404948233000013, 24.002443742],
          [120.405033876000061, 24.002378107],
          [120.405110669999985, 24.002283578999982],
          [120.405178800000044, 24.002118951999961],
          [120.405193031000067, 24.001954096],
          [120.405190090000033, 24.001616038999973],
          [120.405222552000055, 24.001393548999982],
          [120.40526065499999, 24.000962414999975],
          [120.405270128000083, 24.000855264999974],
          [120.405306401000061, 24.00078119399999],
          [120.405388025000093, 24.000612482999973],
          [120.405419768, 24.00054664799999],
          [120.405641386000056, 24.000213577999979],
          [120.405740861000027, 24.000069676999978],
          [120.405840241000064, 23.999946370000014],
          [120.405995033000039, 23.999792488000018],
          [120.406076146000018, 23.999735087],
          [120.406170657000061, 23.99969422600001],
          [120.406287665000022, 23.999645197999989],
          [120.406440490000023, 23.999621059999967],
          [120.406642854000097, 23.999568245000017],
          [120.406827140000019, 23.999540099999962],
          [120.407092384000066, 23.99948752800001],
          [120.407200351000014, 23.99945084499999],
          [120.407326266000041, 23.999418347999985],
          [120.407429608000015, 23.99941049399999],
          [120.407492414000103, 23.999427223999966],
          [120.407780175000084, 23.99936237799999],
          [120.407987198, 23.99927246899999],
          [120.40814479800008, 23.999217591999955],
          [120.408333530000036, 23.999109030999964],
          [120.408419851000076, 23.999061932999975],
          [120.408523363000086, 23.999021240999969],
          [120.408644156000037, 23.998967964000023],
          [120.408713386000045, 23.998892359],
          [120.408761863, 23.998835633999967],
          [120.408807128000021, 23.998728333],
          [120.408824507000077, 23.998693618999969],
          [120.408797314000026, 23.99861449099999],
          [120.408729106999985, 23.99846564199996],
          [120.408677732, 23.998402220999974],
          [120.408629831000098, 23.998332493],
          [120.408599019000022, 23.998291273999982],
          [120.408588182000017, 23.998255276999981],
          [120.408487944000058, 23.99808858099998],
          [120.408398870000042, 23.997888084999989],
          [120.408261949999982, 23.997553998999965],
          [120.408164947000031, 23.997389167999973],
          [120.408103399000098, 23.997267793999956],
          [120.407967033000105, 23.996964469000012],
          [120.407610685, 23.996067569999955],
          [120.407377749000034, 23.995476798],
          [120.40697044500007, 23.99441442099997],
          [120.406784227, 23.993914274999987],
          [120.406376168000065, 23.992985534999985],
          [120.406189557000062, 23.992571905000027],
          [120.405947795000088, 23.992040083999989],
          [120.405681557000094, 23.991442552000017],
          [120.4060649810001, 23.990976059999959],
          [120.406918074000018, 23.989961493],
          [120.40741776600008, 23.989361749],
          [120.407512536000027, 23.989248066999988],
          [120.406118436000028, 23.9882605],
          [120.404816054000094, 23.98733526099999],
          [120.404101411000042, 23.98683039599999],
          [120.403396812000096, 23.986340040999984],
          [120.403285865000043, 23.986245234999988],
          [120.403239664999987, 23.986044497],
          [120.403138012000014, 23.985792428999986],
          [120.402981266000083, 23.985410359999982],
          [120.402861183000041, 23.985201975999967],
          [120.402628, 23.984674110999979],
          [120.402560347000076, 23.984481162999984],
          [120.402454105000061, 23.984295920000012],
          [120.402377393000052, 23.984209112],
          [120.402257990000066, 23.984090669999979],
          [120.402194023000106, 23.984027495999989],
          [120.402156122000065, 23.983885787],
          [120.402105029000026, 23.98378061399999],
          [120.402058361000044, 23.98368212099999],
          [120.402007572, 23.983548218999974],
          [120.401960848000044, 23.983461528],
          [120.40142764000008, 23.98501727099999],
          [120.40118999700006, 23.985801606999964],
          [120.400651879000037, 23.987164679999967],
          [120.400406414000017, 23.987862141999969],
          [120.400230312000076, 23.988177042],
          [120.399899294000093, 23.988649828],
          [120.399469172000067, 23.989077548999987],
          [120.398813131, 23.989628544999988],
          [120.39814860200012, 23.990264942999982],
          [120.397423204999981, 23.99080869299999],
          [120.396903925000061, 23.991231381000024],
          [120.396653307000079, 23.991426942000011],
          [120.396453001000054, 23.99154408899998],
          [120.395460081, 23.991808798000012],
          [120.393706527000063, 23.99226845299999],
          [120.392370654000047, 23.992636612],
          [120.391168537, 23.99290134300001],
          [120.389192063, 23.993349114999983],
          [120.388296803, 23.99351348399999],
          [120.387386327000058, 23.993643610999957],
          [120.38696786199999, 23.993678879],
          [120.386106808000036, 23.99374930499998],
          [120.38459888, 23.993902951999956],
          [120.383536131000028, 23.99399577500002],
          [120.382186652000073, 23.994152585999974],
          [120.380784003000031, 23.994289057999978],
          [120.378671748000073, 23.994297045999971],
          [120.37759645200002, 23.994319188999985],
          [120.376774016, 23.994282723000012],
          [120.37655797900004, 23.994189066999965],
          [120.37536655200006, 23.993302453],
          [120.373894798000038, 23.991995654999968],
          [120.371054229000052, 23.989632067],
          [120.369631925, 23.98852559599996],
          [120.36906097399999, 23.988158347],
          [120.368933641999988, 23.988124174999982],
          [120.368752569000108, 23.988123430000023],
          [120.36811078900007, 23.988222683999975],
          [120.367663887000049, 23.988354511],
          [120.364645293000081, 23.989339678],
          [120.362666345000079, 23.989950588999971],
          [120.361573720000024, 23.990370929999969],
          [120.360465296000029, 23.990639456999965],
          [120.358844205000082, 23.990996875],
          [120.35816645400007, 23.991054737999981],
          [120.357720314000062, 23.991052870000019],
          [120.357025886000073, 23.991141002],
          [120.355003427000028, 23.991760352000021],
          [120.35427847299999, 23.991966240999989],
          [120.353988133000016, 23.99211698],
          [120.35354918500002, 23.99239108599998],
          [120.353228065000067, 23.992494206999986],
          [120.352390088000092, 23.992547656999964],
          [120.351470283000026, 23.992420297],
          [120.351078295000093, 23.992219199000012],
          [120.349357515000065, 23.99095825],
          [120.316451517, 23.99923482899996],
          [120.31766426, 24.000935699000017],
          [120.318864788000027, 24.002131475999974],
          [120.320015342000033, 24.003338650999968],
          [120.322366448000011, 24.005350922999959],
          [120.324217476000058, 24.006788361999988],
          [120.326781343000107, 24.00869739],
          [120.328507127000051, 24.01035301400001],
          [120.329932848, 24.011468422],
          [120.332021681, 24.01238901399999],
          [120.332434438000064, 24.012596143999968],
          [120.334135269000043, 24.013941528000011],
          [120.335285675, 24.01574594100002],
          [120.336060641000017, 24.01789464399999],
          [120.336297789999975, 24.019905134999966],
          [120.33675965799999, 24.023569799],
          [120.336996718, 24.025694966999986],
          [120.337183764000102, 24.027992383000015],
          [120.337445930000058, 24.029841880999964],
          [120.33779579400003, 24.031289463999975],
          [120.338808619000019, 24.033047550999949],
          [120.340359148000047, 24.035116155999987],
          [120.340909248, 24.036425988],
          [120.341408719000015, 24.039619339],
          [120.34173196499999, 24.046889545999964],
          [120.341846519, 24.047894789999962],
          [120.342243150000058, 24.047749031],
          [120.344519205000111, 24.046928302],
          [120.346795151000023, 24.04612337699999],
          [120.349070990000087, 24.045334233999974],
          [120.351346719000048, 24.044560876999963],
          [120.353622343000083, 24.043803312],
          [120.355897862, 24.043061540999972],
          [120.358173278000095, 24.04233554599999],
          [120.360448584000096, 24.041625351999954],
          [120.362723784000082, 24.040930950999989],
          [120.364998885000091, 24.040252335999966],
          [120.367273883000038, 24.039589512999989],
          [120.369548782000038, 24.038942474999981],
          [120.37132933800001, 24.03844839],
        ],
      ],
    },
  },
];
